module.exports = {
  QuickSearchAdNumber: 'การค้นหาอย่างรวดเร็ว: รหัสโฆษณา',
  Remove: 'เลิกใช้งาน',
  Publish: 'เผยแพร่',
  AdNumber: 'รหัสโฆษณา',
  SubjectName: 'หัวข้อ/ชื่อ',
  AdContent: 'เนื้อหาโฆษณา',
  Advertiser: 'ผู้ลงโฆษณา',
  AdPosition: 'พื้นที่โฆษณา',
  BelongToPage: 'หน้าที่เกี่ยวข้อง',
  BelongToModule: 'โมดูลที่เกี่ยวข้อง',
  BelongToSystem: 'ระบบที่เกี่ยวข้อง',
  Status: 'สถานะ',
  TargetAudience: 'กลุ่มเป้าหมาย',
  Global: 'ทั้งระบบ',
  Creator: 'ผู้สร้าง',
  CreationDate: 'วันที่สร้าง',
  Modifier: 'ผู้แก้ไข',
  ModificationDate: 'วันที่แก้ไข',
  PromotionPeriod: 'ระยะเวลาโปรโมท',
  EffectiveTime: 'เวลาเริ่มมีผล',
  ExpirationTime: 'เวลาหมดอายุ',
  PleaseCheckOneEntry: 'กรุณาเลือกข้อมูล 1 รายการ!',
  ContainsUnremovedData: 'มีข้อมูลที่ยังไม่ได้เลิกใช้งาน!',
  AreYouWantToDelete: 'ยืนยันที่จะลบหรือไม่?',
  PleaseSelectOneEntry: 'กรุณาเลือกข้อมูล 1 รายการ!',
  PleaseOnlySelectOneRecord: 'กรุณาเลือกเพียง 1 รายการ!',
  ContainsAlreadyRemovedData: 'มีข้อมูลที่ถูกเลิกใช้งานแล้ว!',
  AreYouWantToRemove: 'ยืนยันที่จะเลิกใช้งานหรือไม่?',
  AreYouWantToPublish: 'ยืนยันที่จะเผยแพร่หรือไม่?',
  ThePositionHasBeenDisabled: 'พื้นที่โฆษณานี้ถูกปิดการใช้งานแล้ว!',
  TheReachedTheMaximumPlacements: 'พื้นที่โฆษณานี้มีจำนวนโฆษณาสูงสุดแล้ว!',
  RemainingAreNotEnoughCheck: 'พื้นที่โฆษณาที่เหลือไม่เพียงพอ กรุณาตรวจสอบ!',
  ContainsPublishedOrExpiredData: 'มีข้อมูลที่เผยแพร่แล้วหรือหมดอายุแล้ว!',
  View: 'ดู',
  Edit: 'แก้ไข',
  Enable: 'เปิดใช้งาน',
  Disable: 'ปิดใช้งาน',
  AdPositionNumber: 'รหัสพื้นที่โฆษณา',
  CurrentlyPlacedAdCount: 'จำนวนโฆษณาที่ลงแล้ว',
  MaximumSupportedAdCount: 'จำนวนโฆษณาสูงสุดที่รองรับ',
  CurrentDisabledAndCannotEdited: 'ข้อมูลปัจจุบันยังไม่ได้ปิดใช้งาน ไม่สามารถแก้ไขได้!',
  AreYouWantToDisable: 'ยืนยันที่จะปิดใช้งานหรือไม่?',
  AreYouWantToDisable2: 'ยืนยันที่จะปิดใช้งานหรือไม่?',
  ContainsNonDisabledData: 'มีข้อมูลที่ไม่ได้ปิดใช้งาน!',
  AreYouWantToEnable: 'ยืนยันที่จะเปิดใช้งานหรือไม่?',
  TemplateManagement: 'การจัดการเทมเพลต',
  TemplateTypeManagement: 'การจัดการประเภทเทมเพลต',
  ConfigurationManagement: 'การจัดการการตั้งค่า',
  MappingManagement: 'การจัดการแมปปิ้ง',
  InitializeTemplateManagement: 'การจัดการเทมเพลตเริ่มต้น',
  BusinessStatusManagement: 'การจัดการสถานะธุรกิจ',
  TriggerTypeManagement: 'การจัดการประเภททริกเกอร์',
  FileTypeManagement: 'การจัดการประเภทไฟล์',
  DefaultValueManagement: 'การจัดการค่าดีฟอลต์',
  ValidationRuleConfiguration: 'การกำหนดกฎการตรวจสอบ',
  EDITemplateSetting: 'การตั้งค่าเทมเพลต EDI',
  SeaFreightOnlineCheckingSettings: 'การตั้งค่าการตรวจสอบเอกสารทางทะเลออนไลน์',
  ShippingRouteAndWarehouseConfiguration: 'การกำหนดเส้นทางเดินเรือและคลังสินค้า',
  PushServiceConfiguration: 'การกำหนดค่าบริการผลักดัน',
  InvoiceCustomRemark: 'หมายเหตุกำหนดเองในใบแจ้งหนี้',
  CustomRemarkOne: 'หมายเหตุกำหนดเอง 1',
  CustomRemarkTwo: 'หมายเหตุกำหนดเอง 2',
  EmailTemplateManagement: 'การจัดการเทมเพลตอีเมล',
  ReleaseConfiguration: 'การกำหนดการปล่อยเอกสาร',
  PromotionTimeRange: 'ช่วงเวลาโปรโมชัน',
  JumpLink: 'ลิงก์เปลี่ยนหน้า',
  Cancel: 'ยกเลิก',
  Save: 'บันทึก',
  Return: 'กลับ',
  Homepage: 'หน้าหลัก',
  SelectAll: 'เลือกทั้งหมด',
  DeselectAll: 'ยกเลิกการเลือกทั้งหมด',
  AreYouWantToCancel: 'ยืนยันการยกเลิกหรือไม่?',
  NumberOfClickedUsers: 'จำนวนผู้ใช้ที่คลิก',
  BelongToCompany: 'บริษัทที่สังกัด',
  UserType: 'ประเภทผู้ใช้',
  Username: 'ชื่อผู้ใช้',
  PlatformCustomerService: 'บริการลูกค้าของแพลตฟอร์ม',
  ClickTime: 'เวลาที่คลิก',
  BrowsingTime: 'เวลาที่ดู',
  StartTime: 'เวลาเริ่มต้น:',
  EndTime: 'เวลาสิ้นสุด:',
  SequenceNumber: 'หมายเลขลำดับ',
  Code: 'โค้ด',
  ChineseName: 'ชื่อภาษาจีน',
  EnglishName: 'ชื่อภาษาอังกฤษ',
  NodeType: 'ประเภทโหนด',
  Remarks: 'หมายเหตุ',
  CreateStatus: 'สถานะใหม่',
  Delete: 'ลบ',
  IsItPublic: 'เปิดเผยหรือไม่',
  CreateStatusDetail: 'รายละเอียดสถานะใหม่',
  EditStatus: 'แก้ไขสถานะ',
  DeleteSuccessful: 'ลบสำเร็จ',
  SaveSuccessful: 'บันทึกสำเร็จ',
  PleaseEnterCode: 'กรุณาใส่โค้ด',
  PleaseEnterNodeType: 'กรุณาใส่ประเภทโหนด',
  PleaseEnterCodeChineseName: 'กรุณาใส่ชื่อภาษาจีนของโค้ด',
  PleaseEnterCodeEnglishName: 'กรุณาใส่ชื่อภาษาอังกฤษของโค้ด',
  StatusType: 'ประเภทสถานะ',
  ExternalCode: 'รหัสภายนอก',
  Name: 'ชื่อ',
  GenerateElectronicFile: 'สร้างไฟล์อิเล็กทรอนิกส์',
  FileType: 'ประเภทไฟล์',
  DataService: 'บริการข้อมูล',
  ReportTemplate: 'เทมเพลตรายงาน',
  PushObject: 'ผู้รับเป้าหมาย',
  PushChannel: 'ช่องทางการส่ง',
  SubjectTemplate: 'เทมเพลตหัวข้อ',
  BodyTemplate: 'เทมเพลตเนื้อหา',
  DataItem: 'รายการข้อมูล',
  AttachmentFileType: 'ประเภทไฟล์แนบ',
  TemplateSubject: 'หัวข้อเทมเพลต',
  TemplateContent: 'เนื้อหาเทมเพลต',
  TemplateExample: 'ตัวอย่างเทมเพลต',
  SendTest: 'ส่งทดสอบ',
  ConfigureSOPMessagePush: 'กำหนดค่าการส่งข้อความ SOP',
  EditStatusDetail: 'แก้ไขรายละเอียดสถานะ',
  InitialStatus: 'สถานะเริ่มต้น',
  AutoTrigger: 'ทำงานอัตโนมัติ',
  StatusChangeNotification: 'แจ้งเตือนการเปลี่ยนสถานะ',
  SendNotification: 'ส่งการแจ้งเตือน',
  NoNotification: 'ไม่ส่งการแจ้งเตือน',
  DesignatedPosition: 'ตำแหน่งที่กำหนด',
  Sales: 'ฝ่ายขาย',
  Operation: 'ปฏิบัติการ',
  CustomerService: 'บริการลูกค้า',
  OverseasCustomerService: 'บริการลูกค้าต่างประเทศ',
  Documentation: 'เอกสาร',
  ShippingLineManager: 'ผู้รับผิดชอบเส้นทาง',
  DesignatedPersonnel: 'บุคคลที่กำหนด',
  Email: 'อีเมล',
  SopPushLog: 'บันทึกการส่ง SOP',
  Confirm: 'ยืนยัน',
  SendTo: 'ส่งถึง:',
  Note: 'หมายเหตุ',
  WillBusinessDetailsAndNodes: 'จะลบรายละเอียดธุรกิจและโหนด SOP ที่เกี่ยวข้อง',
  PleaseEnterContent: 'กรุณากรอกเนื้อหา',
  NotStarted: 'ยังไม่เริ่ม',
  InProgress: 'กำลังดำเนินการ',
  Completed: 'เสร็จสิ้น',
  Abnormal: 'ผิดปกติ',
  BookingSuccessful: 'จองสำเร็จ',
  WarehouseEntryNotice: 'แจ้งเตือนเข้าคลัง',
  CustomsClearance: 'ปล่อยศุลกากร',
  SailingNotice: 'แจ้งเตือนออกเรือ',
  IssuanceOfBillOfLading: 'ออกใบตราส่งสินค้า',
  Customer: 'ลูกค้า',
  DestinationPortAgent: 'ตัวแทนท่าปลายทาง',
  DesignatedFreightForwarder: 'ตัวแทนสินค้าที่กำหนด',
  DeparturePortAgent: 'ตัวแทนท่าเรือต้นทาง',
  DesignatedPositionsAndPersonnel: 'ตำแหน่งงานที่กำหนดและบุคคลที่กำหนด',
  PleaseEnterTheCode: 'กรุณาใส่รหัส',
  PleaseEnterTheChineseName: 'กรุณาใส่ชื่อภาษาจีน',
  ChineseNameLengthExceeded20: 'ชื่อภาษาจีนยาวเกิน 20 ตัวอักษร!',
  PleaseEnterTheEnglishName: 'กรุณาใส่ชื่อภาษาอังกฤษ',
  PleaseSelectTheStatusType: 'กรุณาเลือกประเภทสถานะ!',
  PleaseSelectTheTriggerType: 'กรุณาเลือกประเภทการกระตุ้น',
  PleaseSelectTheStatusType2: 'กรุณาเลือกประเภทสถานะ',
  TheAlreadyExistsPleaseEnter: 'มีรหัสซ้ำอยู่แล้ว กรุณาใส่ใหม่!',
  TheAlreadyExistsPleaseEnter2: 'มีชื่อภาษาจีนซ้ำอยู่แล้ว กรุณาใส่ใหม่!',
  TheAlreadyExistsPleaseEnter3: 'มีชื่อภาษาอังกฤษซ้ำอยู่แล้ว กรุณาใส่ใหม่!',
  SaveSuccess: 'บันทึกสำเร็จ',
  DeleteSuccess: 'ลบสำเร็จ',
  BusinessDetailsDoNotExist: 'ไม่มีรายละเอียดธุรกิจ',
  PleaseEnterTheSubjectTemplate: 'กรุณาใส่เทมเพลตหัวข้อ',
  PleaseTheTextTemplateContent: 'กรุณาใส่เนื้อหาเทมเพลต',
  PleaseEnterTheTemplateContent: 'กรุณาใส่เนื้อหาเทมเพลต',
  PleaseEnterTheTemplateExample: 'กรุณาใส่ตัวอย่างเทมเพลต',
  PleaseFirstSelectData: 'กรุณาเลือกข้อมูลก่อน',
  AreWantToDeleteRecord: 'ยืนยันที่จะลบรายการที่เลือกหรือไม่?',
  Tips: 'คำเตือน',
  PleaseTheTestEmailAddress: 'กรุณาใส่อีเมลทดสอบ!',
  EmailFormatError: 'รูปแบบอีเมลไม่ถูกต้อง!',
  EmailCannotExceed128Characters: 'อีเมลต้องไม่เกิน 128 ตัวอักษร',
  PleaseTestMobilePhoneNumber: 'กรุณาใส่เบอร์โทรศัพท์ทดสอบ!',
  MobileCanOnlyBeNumbers: 'เบอร์โทรศัพท์ต้องเป็นตัวเลขที่ถูกต้อง!',
  MobilePhoneNumberFormatError: 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง!',
  SendSuccess: 'ส่งสำเร็จ!',
  SendFailure: 'ส่งไม่สำเร็จ!',
  APIOutputAdditionalInformation: 'ข้อมูลเพิ่มเติมที่ส่งออกจาก API',
  OutputDescription: 'คำอธิบายการส่งออก',
  OutputIdentification: 'ตัวระบุการส่งออก',
  DataSource: 'แหล่งที่มาของข้อมูล',
  DataField: 'ฟิลด์ข้อมูล',
  WarningSwitch: 'สวิตช์การแจ้งเตือน',
  SailingTimeETD: 'เวลาออกเรือ (ETD)',
  ArrivalTimeETA: 'เวลาถึงท่า (ETA)',
  OpenPortTime: 'เวลาเปิดท่า',
  ClosingPortTime: 'เวลาปิดท่า',
  ClosingTimeForOrders: 'เวลาปิดรับเอกสาร',
  CustomsClosingTime: 'เวลาปิดด่าน',
  ScheduledBerthingDate: 'วันที่วางแผนจอดเรือ',
  ScheduledDepartureDate: 'วันที่วางแผนออกเรือ',
  WarningTime: 'เวลาแจ้งเตือน',
  Advance: 'ล่วงหน้า',
  Delay: 'เลื่อนออกไป',
  WarningSettings: 'การตั้งค่าแจ้งเตือน',
  TurnOnWarning: 'เปิดการแจ้งเตือน',
  TurnOffWarning: 'ปิดการแจ้งเตือน',
  HoursWarningReminder: 'ชั่วโมง แจ้งเตือน',
  Highest: 'สูงสุด',
  High: 'สูง',
  Medium: 'ปานกลาง',
  Low: 'ต่ำ',
  Relation: 'ความสัมพันธ์',
  FilterValue: 'ค่ากรอง',
  ValidationCondition: 'เงื่อนไขการตรวจสอบ',
  New: 'สร้างใหม่',
  And: 'และ',
  Or: 'หรือ',
  FilterBasis: 'เกณฑ์การกรอง',
  CurrentlyModeUnableToNew: 'ขณะนี้อยู่ในสถานะแก้ไข ไม่สามารถสร้างใหม่ได้',
  CurrentlyModeUnableToDelete: 'ขณะนี้อยู่ในสถานะแก้ไข ไม่สามารถลบได้',
  PleaseSelectAFilterBasis: 'กรุณาเลือกเกณฑ์การกรอง',
  PleaseSelectTheFilterValue: 'กรุณาเลือกค่ากรอง',
  ValidationExpression: 'นิพจน์การตรวจสอบ',
  PositiveOperation: 'การดำเนินการปกติ',
  PreSubmit: 'เตรียมส่ง',
  Submitted: 'ส่งแล้ว',
  Reviewed: 'ตรวจสอบแล้ว',
  ValidationItem: 'รายการตรวจสอบ',
  Empty: 'ว่าง',
  PleaseSelectValidationItem: 'กรุณาเลือกรายการตรวจสอบ',
  RuleName: 'ชื่อกฎ',
  ValidationNode: 'โหนดตรวจสอบ',
  ValidationType: 'ประเภทการตรวจสอบ',
  ValidationMode: 'โหมดการตรวจสอบ',
  EmailAddress: 'ที่อยู่อีเมล',
  Add: 'เพิ่มใหม่',
  Refresh: 'รีเฟรช',
  ValidationRules: 'กฎการตรวจสอบ',
  AllowOperationAfterValidationFails: 'เมื่อตรวจสอบไม่ผ่าน อนุญาตให้ดำเนินการต่อหรือไม่?',
  Yes: 'ใช่',
  No: 'ไม่',
  Company: 'บริษัท',
  ContinueValidation: 'ตรวจสอบต่อ',
  CurrentlyYouSureYouRefresh: 'ขณะนี้อยู่ในสถานะแก้ไข แน่ใจหรือไม่ที่จะรีเฟรช?',
  FailedToInitializeData: 'การเริ่มต้นข้อมูลล้มเหลว',
  AreRuleAssociatedValidationDeleted: 'ยืนยันที่จะลบกฎการตรวจสอบนี้หรือไม่? นิพจน์การตรวจสอบและเงื่อนไขการตรวจสอบที่เกี่ยวข้องจะถูกลบด้วย!',
  PleaseSelectTheBranchOffice: 'กรุณาเลือกสาขา',
  PleaseEnterTheRuleName: 'กรุณากรอกชื่อกฎ',
  PleaseSelectTheRuleNode: 'กรุณาเลือกโหนดกฎ',
  PleaseSelectTheRuleType: 'กรุณาเลือกประเภทกฎ',
  PleaseSelectTheRuleMode: 'กรุณาเลือกโหมดกฎ',
  CompanyName: 'ชื่อบริษัท',
  PleaseConfigurationNameOrRemarks: 'กรุณากรอกชื่อการตั้งค่าหรือหมายเหตุ',
  Type: 'ประเภท',
  InterfaceSettings: 'การตั้งค่าอินเทอร์เฟซ',
  ConfigurationName: 'ชื่อการตั้งค่า',
  DefaultValue: 'ค่าเริ่มต้น',
  EditConfigurationItem: 'แก้ไขรายการกำหนดค่า',
  EditConfigurationDefinition: 'แก้ไขนิยามการกำหนดค่า:',
  Search: 'ค้นหา',
  DisplaySettings: 'การตั้งค่าการแสดงผล',
  ApplicationSettings: 'การตั้งค่าแอปพลิเคชัน',
  ReadAndWriteSettings: 'การอ่านและการเขียนการตั้งค่า',
  CanEditable: 'แก้ไขได้',
  VisibleToDesignatedPersonnel: 'มองเห็นได้สำหรับบุคลากรที่กำหนด:',
  FieldPermissionSettings: 'การตั้งค่าสิทธิ์ฟิลด์',
  ConfigurationItemconfigId: 'รายการกำหนดค่า (configId)',
  TypedataType: 'ประเภท (dataType)',
  InterfaceSettingsisClient: 'การตั้งค่าอินเทอร์เฟซ (isClient)',
  BranchOfficeOptionisOfficeOption: 'ตัวเลือกสาขา (isOfficeOption)',
  ServiceSettingsisServer: 'การตั้งค่าบริการ (isServer)',
  OptionalItemliterals: 'ตัวเลือก (literals)',
  ConfigurationNamename: 'ชื่อการกำหนดค่า (name)',
  Remarksremarks: 'หมายเหตุ (remarks)',
  DefaultValuevalue: 'ค่าดีฟอลต์ (value)',
  ConfigurationNameCannotBeEmpty: 'ชื่อการกำหนดค่าไม่สามารถเว้นว่างได้',
  DefaultValueCannotBeEmpty: 'ค่าดีฟอลต์ไม่สามารถเว้นว่างได้',
  PleaseEnterTheBranchOffice: 'กรุณากรอกสาขา',
  Value: 'ค่า',
  ConfigurationItem: 'รายการกำหนดค่า',
  BranchOffice: 'สาขา',
  PleaseSelectAConfigurationDefinition: 'กรุณาเลือกนิยามการกำหนดค่าหนึ่งรายการ',
  BranchOfficeCannotBeEmpty: 'สาขาไม่สามารถเว้นว่างได้!',
  ValueCannotBeEmpty: 'ค่าไม่สามารถเว้นว่างได้!',
  TheConfigurationAlreadyExistsCheck: 'มีการกำหนดค่าสาขาที่ซ้ำกันอยู่แล้ว กรุณาตรวจสอบ',
  ApplyHeadOfficeSettings: 'ใช้การตั้งค่าสำนักงานใหญ่',
  SleepingDays: 'จำนวนวันที่ไม่มีการใช้งาน',
  SigningDays: 'จำนวนวันลงนาม',
  NotificationObject: 'ผู้รับการแจ้งเตือน:',
  Supervisor: 'ผู้บังคับบัญชาระดับสูง',
  NotificationMethod: 'วิธีการแจ้งเตือน:',
  InternalReminder: 'การแจ้งเตือนภายใน',
  HowDaysBeforeExpirationNotice: 'แจ้งเตือนกี่วันก่อนหมดอายุ:',
  Days: 'วัน',
  DayMaintenance: 'การบำรุงรักษาจำนวนวัน:',
  BusinessEntity: 'นิติบุคคลทางธุรกิจ',
  SelectEntityConfigurationItem: 'เลือกรายการกำหนดค่านิติบุคคล',
  BranchOffice2: 'สาขา:',
  EntitySelection: 'การเลือกรายการ:',
  AffiliatedBranchOffice: 'สาขาที่สังกัด',
  EntityCode: 'รหัสนิติบุคคล',
  EntityName: 'ชื่อนิติบุคคล',
  FieldCode: 'รหัสฟิลด์',
  FieldName: 'ชื่อฟิลด์',
  ValueType: 'ประเภทค่า',
  All: 'ทั้งหมด',
  SelectBranch: 'เลือกสาขา',
  Unused: 'ยังไม่ได้ใช้',
  Used: 'ใช้งานแล้ว',
  Example8180ThisTicketOnlyDollars: 'ตัวอย่าง: USD:355/อัตราแลกเปลี่ยน:6.8180/บัตรนี้รับเฉพาะดอลลาร์สหรัฐ',
  Precautions: 'ข้อควรระวัง:',
  SavedEffectFromTheInvoice: 'การกำหนดค่าจะมีผลใช้บังคับจากใบแจ้งหนี้ถัดไปหลังจากบันทึก',
  EBeLessThanCharacters: 'หมายเหตุใบแจ้งหนี้อิเล็กทรอนิกส์ต้องน้อยกว่า 100 ตัวอักษร',
  PaperBeLessThanCharacters: 'หมายเหตุบนตั๋วกระดาษต้องไม่เกิน 200 ตัวอักษร',
  AutomaticallyALineDoesShow: 'จะขึ้นบรรทัดใหม่อัตโนมัติเมื่อแสดงไม่พอในหนึ่งบรรทัด',
  PDFCanDisplayUpLines: 'ช่องหมายเหตุในใบแจ้งหนี้รูปแบบ PDF แสดงได้สูงสุดสามบรรทัด',
  SerialNumber: 'ลำดับที่',
  ExternalFileType: 'ประเภทไฟล์ภายนอก',
  NecessaryScenario: 'สถานการณ์ที่จำเป็น',
  OriginalScenario: 'สถานการณ์ต้นฉบับ',
  TypePermission: 'สิทธิ์ประเภท',
  AllPositions: 'ทุกตำแหน่งงาน',
  Client: 'หน่วยงานที่มอบหมาย',
  Shipper: 'ผู้ส่งสินค้า',
  Consignee: 'ผู้รับสินค้า',
  OverseasAgent: 'ตัวแทนต่างประเทศ',
  BookingAgent: 'ตัวแทนจองพื้นที่',
  PleaseSelectBookingAgent: 'กรุณาเลือกตัวแทนจองพื้นที่',
  ExternalAccess: 'การเข้าถึงภายนอก',
  B2BCustomer: 'ลูกค้า B2B',
  B2BDesignatedCargoAgent: 'ตัวแทนสินค้าที่กำหนดของ B2B',
  B2BDestinationPortAgent: 'ตัวแทนท่าเรือปลายทาง B2B',
  B2BConsignee: 'ผู้รับสินค้า B2B',
  TemplateOutputName: 'ชื่อเอาต์พุตเทมเพลต',
  Delimiter: 'ตัวคั่น',
  NoteTemplateNameAccordingNeeds: 'หมายเหตุ: กรุณากำหนดชื่อเทมเพลตที่ส่งออกตามความต้องการของคุณ',
  DefaultSync: 'ซิงค์โดยค่าเริ่มต้น',
  UsedFileAutomaticallySynchronizesBusiness: 'ใช้เพื่อตั้งค่าการซิงค์ไฟล์ประเภทนี้โดยอัตโนมัติระหว่างธุรกิจนำเข้าและส่งออก',
  CustomTemplateName: 'ชื่อเทมเพลตที่กำหนดเอง',
  TemplateName: 'ชื่อเทมเพลต',
  Underscore_: 'ขีดล่าง _',
  Hyphen: 'ขีดกลาง -',
  CreateFileClassification: 'การจัดประเภทไฟล์ใหม่',
  CreateFileType: 'ประเภทไฟล์ใหม่',
  Create: 'สร้างใหม่',
  Modify: 'แก้ไข',
  FileClassification: 'การจัดประเภทไฟล์',
  CurrentOperationStatusIsAbnormal: 'สถานะการดำเนินการปัจจุบันผิดปกติ!',
  PleaseSelectChineseName: 'กรุณาเลือกชื่อภาษาจีน',
  CurrentOperatingStatusAbnormal: 'สถานะการดำเนินการปัจจุบันผิดปกติ',
  CondAlreadyExists: 'cond มีอยู่แล้ว',
  EDIFileDefaultTypeDefaultFileType: 'ประเภทไฟล์ EDI เริ่มต้น (DefaultFileType)',
  Emailemail: 'อีเมล (email)',
  EDIFileEncodingTypeEncodingType: 'ประเภทการเข้ารหัสไฟล์ EDI (EncodingType)',
  EDIFileCombinationMethodFileCombineType: 'วิธีการรวมไฟล์ EDI (FileCombineType)',
  PartnerCodeParnterId: 'รหัสพันธมิตร (ParnterId)',
  SendFTPFileNamePrefixsendFilePrefix: 'คำนำหน้าชื่อไฟล์ FTP ที่ส่ง (sendFilePrefix)',
  SendFTPAddressTypesendType: 'ประเภทที่อยู่ FTP ที่ส่ง (sendType)',
  ServiceTypeServiceType: 'ประเภทบริการ (ServiceType)',
  TemplateDescriptionTemplateDescribe: 'คำอธิบายเทมเพลต (TemplateDescribe)',
  TemplateAccessPathTemplatePath: 'เส้นทางเข้าถึงเทมเพลต (TemplatePath)',
  TemplateTypeTemplateType: 'ประเภทเทมเพลต (TemplateType)',
  ShutNoticeShutOutIdentification: 'ข้อความยกเลิกศุลกากร (Shut-out identification)',
  BootHelperPage: 'หน้าช่วยเหลือการบูต (Boot helper page)',
  EDITemplateMaintenance: 'การบำรุงรักษาเทมเพลต EDI',
  PleaseEDIFileCombinationMethod: 'กรุณาใส่วิธีการรวมไฟล์ EDI',
  EDIMethodMustBeType: 'วิธีการรวมไฟล์ EDI ต้องเป็นประเภทตัวเลข',
  PleaseEnterPartnerCode: 'กรุณาใส่รหัสพันธมิตร',
  PartnerMustBeNumericType: 'รหัสพันธมิตรต้องเป็นประเภทตัวเลข',
  PleaseEnterServiceType: 'กรุณาใส่ประเภทบริการ',
  ServiceMustBeNumericType: 'ประเภทบริการต้องเป็นประเภทตัวเลข',
  PleaseEnterTemplateDescription: 'กรุณาใส่คำอธิบายเทมเพลต',
  PleaseEnterTemplateAccessPath: 'กรุณาใส่เส้นทางเข้าถึงเทมเพลต',
  PleaseEnterTemplateType: 'กรุณาใส่ประเภทเทมเพลต',
  TemplateMustBeNumericType: 'ประเภทเทมเพลตต้องเป็นประเภทตัวเลข',
  ShutMustBeNumericType: 'ข้อความยกเลิกศุลกากรต้องเป็นประเภทตัวเลข',
  CloudStorageID: 'รหัสคลาวด์สตอเรจ',
  TemplateFileCloudStorage: 'คลาวด์สตอเรจสำหรับไฟล์เทมเพลต',
  PleaseTemplateYouWantEdit: 'กรุณาเลือกเทมเพลตที่ต้องการแก้ไข!',
  PleaseTemplateYouWantDelete: 'กรุณาเลือกเทมเพลตที่ต้องการลบ!',
  ConfirmDeletionOfThisTemplate: 'ยืนยันที่จะลบเทมเพลตนี้หรือไม่?',
  TemplateDeletedSuccessfully: 'ลบเทมเพลตสำเร็จ!',
  TemplateDeletionFailed: 'ลบเทมเพลตไม่สำเร็จ!',
  BasicFailedPleaseTryAgain: 'อัปเดตเทมเพลตพื้นฐานไม่สำเร็จ กรุณาลองอีกครั้ง!',
  BasicTemplateUpdateSuccessful: 'อัปเดตเทมเพลตพื้นฐานสำเร็จ!',
  PleaseEnterKeywordsToSearch: 'กรุณาใส่คำสำคัญเพื่อค้นหา',
  EmailTemplateEditing: 'แก้ไขเทมเพลตอีเมล',
  PushingLink: 'ขั้นตอนการผลักดัน',
  TextTemplate: 'เทมเพลตเนื้อหา',
  Reminder: 'คำเตือน',
  SendEmail: 'ส่งอีเมลถึง:',
  OK: 'ตกลง',
  BasicData: 'ข้อมูลพื้นฐาน',
  SystemEmail: 'อีเมลระบบ',
  PicturePictureMustNot10M: 'อัปโหลดรูปภาพไม่สำเร็จ รูปภาพต้องมีขนาดไม่เกิน 10M!',
  PleaseAddProductDescriptionHere: 'กรุณาเพิ่มคำอธิบายผลิตภัณฑ์ที่นี่',
  PreSendingSupplementaryInvitationLink: 'ส่งลิงก์เชิญเพิ่มเติมสำหรับข้อมูลการจัดเตรียม',
  MarineMBLInvitationForProofreading: 'เชิญตรวจสอบ MBL การส่งออกทางทะเล',
  MarineHBLInvitationForProofreading: 'เชิญตรวจสอบ HBL การส่งออกทางทะเล',
  MarineExportBulkPrinting: 'พิมพ์เป็นชุดสำหรับการส่งออกทางทะเล',
  AirCargoStorage: 'คลังสินค้าทางอากาศ',
  BillOfLadingPrintProduction: 'สร้างและพิมพ์ใบตราส่งสินค้า',
  FileHistory: 'ประวัติไฟล์',
  InvoicePush: 'ผลักดันใบแจ้งหนี้',
  OceanShippingAlertReminderEmail: 'อีเมลเตือนภัย-การขนส่งทางทะเล',
  ReminderEmail: 'อีเมลเตือน',
  AirExportAlertReminderEmail: 'อีเมลเตือนภัย-การส่งออกทางอากาศ',
  RailwayAlertReminderEmail: 'อีเมลเตือนภัย-การขนส่งทางรถไฟ',
  AirImportAlertReminderEmails: 'อีเมลเตือนภัย-การนำเข้าทางอากาศ',
  IntegratedAlertReminderEmails: 'อีเมลเตือนภัย-โลจิสติกส์แบบบูรณาการ',
  BookingPageData: 'ข้อมูลหน้าจองพื้นที่',
  ContentTemplate: 'เทมเพลตเนื้อหา',
  Updater: 'ผู้อัปเดต',
  LastUpdateTime: 'เวลาอัปเดตล่าสุด',
  UploadedBeLargerThan20MB: 'ขนาดไฟล์รูปภาพที่อัปโหลดต้องไม่เกิน 20MB',
  PictureInsertionFailed: 'การแทรกรูปภาพล้มเหลว',
  OnlyVieweditOneEmailTemplate: 'อนุญาตให้ดู/แก้ไขเทมเพลตอีเมลได้เพียง 1 รายการ',
  CompanyEmail: 'อีเมลบริษัท',
  PersonalEmail: 'อีเมลส่วนตัว',
  SentSuccessfully: 'ส่งสำเร็จ!',
  ConfirmTheModifiedContent: 'ยืนยันการแก้ไขหรือไม่?',
  ConfirmCancelingTheFilledmodifiedContent: 'ยืนยันการยกเลิกข้อมูลที่กรอก/แก้ไขแล้วหรือไม่?',
  PleaseInTheRecipientsEmail: 'กรุณากรอกอีเมลผู้รับ!',
  MappingType: 'ประเภทการแมป',
  Description: 'คำอธิบาย',
  Condition: 'เงื่อนไข',
  SendingPlatform: 'แพลตฟอร์มการส่ง',
  EnglishName2: 'ชื่อภาษาอังกฤษ',
  ChineseName2: 'ชื่อภาษาจีน',
  OriginalValue: 'ค่าดั้งเดิม',
  NewValue: 'ค่าใหม่',
  EditMapping: 'แก้ไขการแมป',
  CreateMapping: 'สร้างการแมปใหม่',
  PleaseEnterMappingType: 'กรุณากรอกประเภทการแมป',
  PleaseEnterTheOriginalValue: 'กรุณากรอกค่าดั้งเดิม',
  PleaseEnterTheNewValue: 'กรุณากรอกค่าใหม่',
  Branch: 'สาขา',
  EnableAutomaticPush: 'เปิดการผลักดันอัตโนมัติ',
  SOPPushChannel: 'ช่องทางผลักดัน SOP:',
  PushOnlyAfterConfirmingRecipient: 'ผลักดันสถานะ SOP หลังจากยืนยันผู้รับ SOP แล้ว:',
  PleaseSendersEmailWhichEmails: 'โปรดเลือกอีเมลด้านล่างเป็นอีเมลผู้ส่ง และสามารถใช้เมื่อส่งอีเมล',
  Username2: 'ชื่อผู้ใช้:',
  EmailPasswordauthorizationCode: 'รหัสผ่านอีเมล/รหัสอนุญาต:',
  EmailDisplayName: 'ชื่อที่แสดงในอีเมล:',
  SenderServer: 'เซิร์ฟเวอร์ผู้ส่ง:',
  Port: 'พอร์ต:',
  WhenActualSenderIsEmail: 'เมื่อเลือกอีเมลส่วนตัว ผู้ส่งจริงจะเป็นอีเมลที่ลงทะเบียนของแต่ละผู้ใช้',
  CompanyEnglishAbbreviation: 'ชื่อย่อภาษาอังกฤษบริษัท:',
  BasicConfiguration: 'การตั้งค่าพื้นฐาน',
  SMS: 'ข้อความ SMS',
  Open: 'เปิด',
  Close: 'ปิด',
  EmailConfiguration: 'การตั้งค่าอีเมล',
  Signature: 'ลายเซ็น:',
  EnableSignature: 'เปิดใช้งานลายเซ็น',
  SMSConfiguration: 'การตั้งค่า SMS',
  PleaseAProductDescriptionHere: 'กรุณาเพิ่มคำอธิบายผลิตภัณฑ์ที่นี่',
  CompanyAbbreviationCannotBeEmpty: 'ชื่อย่อภาษาจีนบริษัทห้ามว่าง!',
  CompanyUsernameCannotBeEmpty: 'ชื่อผู้ใช้อีเมลบริษัทห้ามว่าง!',
  CompanyCodeCannotBeEmpty: 'รหัสผ่านอีเมล/รหัสอนุญาตอีเมลบริษัทห้ามว่าง!',
  CompanyServerCannotBeEmpty: 'เซิร์ฟเวอร์ผู้ส่งอีเมลบริษัทห้ามว่าง!',
  CompanyNumberMustBeNumber: 'พอร์ตอีเมลบริษัทต้องเป็นตัวเลข!',
  PersonalUsernameCannotBeEmpty: 'ชื่อผู้ใช้อีเมลส่วนตัวห้ามว่าง!',
  PersonalServerCannotBeEmpty: 'เซิร์ฟเวอร์ส่งอีเมลส่วนตัวไม่สามารถเว้นว่างได้!',
  PersonalNumberMustBeNumber: 'หมายเลขพอร์ตอีเมลส่วนตัวต้องเป็นตัวเลขเท่านั้น!',
  AdditionalOutputAssociatedTemplate: 'เทมเพลตที่เกี่ยวข้องกับการส่งออกเพิ่มเติม',
  TemplateEngine: 'เครื่องมือเทมเพลต',
  FilterScript: 'สคริปต์กรอง',
  BranchSerialNumber: 'ลำดับสาขา',
  TemplateFile: 'ไฟล์เทมเพลต',
  TemplateClass: 'ประเภทเทมเพลต',
  TemplateUsage: 'วัตถุประสงค์เทมเพลต',
  Print: 'พิมพ์',
  CreateTemplate: 'สร้างเทมเพลต',
  TemplateFileCloudStorageID: 'รหัสเก็บข้อมูลคลาวด์ไฟล์เทมเพลต',
  TemplateSerialNumber: 'ลำดับเทมเพลต',
  SchemaTypeNotMaintained: 'ยังไม่ได้บำรุงรักษา SchemaType',
  CannotCheckWhetherTheCorrect: 'ไม่พบข้อมูลเทมเพลตพื้นฐาน โปรดตรวจสอบแหล่งข้อมูลเทมเพลตว่าถูกต้องหรือไม่!',
  SchemaTypeCannotBeEmpty: 'Schema Type ไม่สามารถเว้นว่างได้',
  TemplateTypeCannotBeEmpty: 'Template Type ไม่สามารถเว้นว่างได้',
  TemplateDescCannotBeEmpty: 'Template Type Desc ไม่สามารถเว้นว่างได้',
  ChineseNameLengthExceeds20: 'ความยาวชื่อภาษาจีนเกิน 20!',
  PleaseSelectStatusType: 'โปรดเลือกประเภทสถานะ!',
  PleaseSelectATriggerType: 'โปรดเลือกประเภทการกระตุ้น',
  DropThisConditionForGoods: '*ช่องเลือกแบบดรอปดาวน์ว่างหมายถึงไม่พิจารณาเงื่อนไขนั้น เช่น: ไม่พิจารณาประเภทสินค้า',
  PushTarget: 'วัตถุเป้าหมายการผลักดัน',
  BookingSuccess: 'การจองสำเร็จ',
  WarehouseEntryNotification: 'แจ้งเตือนเข้าคลัง',
  BillOfLadingIssuance: 'ออกใบตราส่งสินค้า',
  DesignatedFreightAgent: 'ตัวแทนสินค้าที่กำหนด',
  DesignatedPostAndDesignatedPersonnel: 'ตำแหน่งที่กำหนดและบุคคลที่กำหนด',
  PleaseSelectDataFirst: 'โปรดเลือกข้อมูลก่อน',
  AreToDeleteTheRecord: 'ยืนยันการลบรายการที่เลือกหรือไม่?',
  Hint: 'แจ้งเตือน',
  PleaseEnterTestEmailAddress: 'โปรดป้อนที่อยู่อีเมลทดสอบ!',
  PleaseEnterTestMobileNumber: 'โปรดป้อนหมายเลขโทรศัพท์ทดสอบ!',
  MobileOnlyBeANumber: 'หมายเลขโทรศัพท์ต้องเป็นตัวเลขที่ถูกต้องเท่านั้น!',
  MobileNumberFormatError: 'รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง!',
  SendingSuccessful: 'ส่งสำเร็จ!',
  SendingFailed: 'ส่งไม่สำเร็จ!',
  ChineseName3: 'ชื่อภาษาจีน',
  EnglishName3: 'ชื่อภาษาอังกฤษ',
  PublicOrNot: 'เปิดเผยหรือไม่',
  Remark: 'หมายเหตุ',
  AutomaticTrigger: 'การกระตุ้นอัตโนมัติ',
  DoNotSendNotification: 'ไม่ส่งการแจ้งเตือน',
  DesignatedPost: 'ตำแหน่งที่กำหนด',
  Documentary: 'เอกสาร',
  LineManager: 'ผู้รับผิดชอบเส้นทาง',
  PleaseEnterChineseName: 'โปรดป้อนชื่อภาษาจีน',
  PleaseEnterEnglishName: 'โปรดป้อนชื่อภาษาอังกฤษ',
  PleaseSelectTriggerType: 'โปรดเลือกประเภทการกระตุ้น',
  PleaseSelectStatusType2: 'โปรดเลือกประเภทสถานะ',
  ThereSameCodePleaseEnter: 'มีรหัสซ้ำกันอยู่แล้ว โปรดป้อนใหม่!',
  ThereSameChineseNameEnter: 'มีชื่อภาษาจีนซ้ำกันอยู่แล้ว โปรดป้อนใหม่!',
  ThereSameEnglishNameEnter: 'มีชื่อภาษาอังกฤษซ้ำกันอยู่แล้ว โปรดป้อนใหม่!',
  PleaseEnterFieldName: 'กรุณาใส่ชื่อฟิลด์',
  PleaseEnterFieldEnglishName: 'กรุณาใส่ชื่อฟิลด์ภาษาอังกฤษ',
  AreToDeleteTheType: 'ยืนยันที่จะลบประเภททริกเกอร์หรือไม่?',
  AllCharts: 'แผนภูมิทั้งหมด',
  BusinessCharts: 'แผนภูมิธุรกิจ',
  FinancialCharts: 'แผนภูมิการเงิน',
  ControlMode: 'โหมดควบคุม:',
  ReceivingOrder: 'รับออร์เดอร์',
  Printing: 'พิมพ์',
  BillOfLadingRelease: 'ปล่อยใบตราส่งสินค้า',
  NoDeduction: 'ไม่หักใบตราส่ง',
  OnlyHBL: 'มีเฉพาะ HBL',
  OnlyHBLDeductHBL: 'หักเฉพาะ HBL',
  OnlyMBL: 'มีเฉพาะ MBL',
  OnlyMBLDeductMBL: 'หักเฉพาะ MBL',
  HBLAtTheSameTime: 'มีทั้ง HBL และ MBL',
  HBLAtTheSameTime2: 'หักทั้ง HBL และ MBL',
  OnlyHBLWithoutDeductingMBL: 'หักเฉพาะ HBL ไม่หัก MBL',
  DoHBLOnlyDeductMBL: 'ไม่หัก HBL หักเฉพาะ MBL',
  DocumentCirculation: 'การหมุนเวียนเอกสาร',
  ApplyTheHeadOfficesSettings: 'ใช้การตั้งค่าของบริษัทแม่',
  ReminderMode: 'โหมดเตือน',
  LockingMode: 'โหมดล็อกออร์เดอร์',
  WhenRemindersAndTheLocked: 'เมื่อเกินวงเงินเครดิต จะส่งการเตือนเท่านั้น จะไม่ล็อกใบงาน',
  WhenOrderUntilItApproved: 'เมื่อเกินวงเงินเครดิต จะล็อกใบงานจนกว่าจะปลดล็อกอัตโนมัติหรืออนุมัติพิเศษ',
  NotificationReminder: 'การแจ้งเตือน:',
  LockingControl: 'การควบคุมการล็อก:',
  Event: 'เหตุการณ์',
  IsLocked: 'ล็อกหรือไม่',
  ControlObject: 'วัตถุที่ควบคุม',
  ControlMethod: 'วิธีการควบคุม',
  PrintTemplate: 'เทมเพลตการพิมพ์',
  Document: 'เอกสาร',
  EmailAndReminder: 'อีเมลและการเตือน',
  None: 'ไม่มี',
  SaveAndLock: 'ล็อกหลังจากบันทึก',
  CannotSave: 'ไม่สามารถบันทึกได้',
  BusinessLocked: 'ธุรกิจถูกล็อก',
  BusinessUnlocked: 'ธุรกิจถูกปลดล็อก',
  CreditControlExceed: 'เกินวงเงินเครดิต',
  CreditControlChange: 'การเปลี่ยนแปลงวงเงินเครดิต',
  AddCopyFormalBusiness: 'เพิ่ม/คัดลอกธุรกิจอย่างเป็นทางการ',
  OperationSupervisor: 'หัวหน้าฝ่ายปฏิบัติการ',
  SalesSupervisor: 'หัวหน้าฝ่ายขาย',
  CreditControlSupervisor: 'หัวหน้าฝ่ายควบคุมเครดิต',
  BusinessCustomerService: 'บริการลูกค้าธุรกิจ',
  MBLTabPrint: 'พิมพ์แท็บ MBL',
  MBLSplitMergePrint: 'พิมพ์การแยก/รวม MBL',
  HBLOriginalPrint: 'พิมพ์ต้นฉบับ HBL',
  HBLSplitMergeOriginalPrint: 'พิมพ์ต้นฉบับการแยก/รวม HBL',
  HBLTelexPrint: 'พิมพ์การปล่อยทางอิเล็กทรอนิกส์ HBL',
  HBLSplitMergeTelexPrint: 'พิมพ์การปล่อยทางอิเล็กทรอนิกส์การแยก/รวม HBL',
  BookingTabPrint: 'พิมพ์แท็บการจอง',
  BasicTab: 'แท็บพื้นฐาน',
  MAWBTab: 'แท็บ MAWB',
  HAWBTab: 'แท็บ HAWB',
  BookingEDI: 'EDI การจอง',
  BillOfLadingEDI: 'EDI ใบตราส่ง',
  ReturnOrder: 'การคืนเอกสาร',
  AbnormalStatus: 'สถานะผิดปกติ',
  User: 'ผู้ใช้',
  IPAddress: 'ที่อยู่ IP',
  PleaseEnterTheIPAddress: 'กรุณาใส่ที่อยู่ IP',
  IndicatesUnrestricted: 'หมายถึงไม่มีการจำกัด',
  IPAddressCannotBeEmpty: 'ที่อยู่ IP ไม่สามารถเว้นว่างได้',
  PleaseSelectAUser: 'กรุณาเลือกผู้ใช้',
  ThisAlreadyAddedAnWhitelist: 'ผู้ใช้นี้ถูกเพิ่มในรายการขาว IP แล้ว',
  ExistingSameIPAddress: 'ที่อยู่ IP ซ้ำกันมีอยู่แล้ว',
  PleaseSelectData: 'กรุณาเลือกข้อมูล',
  BusinessType: 'ประเภทธุรกิจ',
  BillOfLadingType: 'ประเภทใบตราส่ง',
  DesignatedShippingLine: 'ระบุบริษัทเรือ',
  Expression: 'นิพจน์',
  Example: 'ตัวอย่าง',
  LetterSuffix: 'คำต่อท้ายตัวอักษร',
  LetterexcludingIAndO: 'คำต่อท้ายตัวอักษร (ไม่รวม I และ O)',
  NumberSuffix: 'คำต่อท้ายตัวเลข',
  MasterBillExtension: 'หมายเลขเอกสารหลักต่อเนื่อง',
  SuffixSeparator: 'ตัวคั่นคำต่อท้าย',
  Constant: 'ค่าคงที่',
  AddRule: 'เพิ่มกฎ',
  PleaseEnterRuleName: 'กรุณาใส่ชื่อกฎ',
  Reset: 'รีเซ็ต',
  ServiceCodeMaintenance: 'บำรุงรักษารหัสบริการ',
  BusinessTypelob: 'ประเภทธุรกิจ (lob)',
  CargoPickupType: 'ประเภทการรับสินค้า',
  BranchCodeoffice: 'รหัสสาขา (office)',
  Salesperson: 'พนักงานขาย',
  NetCodenetCode: 'รหัสผู้ดูแลเครือข่าย (netCode)',
  SalesDepartment: 'ฝ่ายขาย',
  OperationsDepartment: 'ฝ่ายปฏิบัติการ',
  OverseasWarehouseCodeFBAFC: 'รหัสคลังสินค้าต่างประเทศ (FBA FC)',
  PortCodeport: 'รหัสท่าเรือ (port)',
  DeliveryPlaceCodeport: 'รหัสสถานที่ส่งมอบ (port)',
  PolCode: 'รหัสท่าเรือต้นทาง (POL)',
  DeparturePortCode: 'รหัสท่าเรือต้นทาง',
  DestinationPortCode: 'รหัสท่าเรือปลายทาง',
  DeparturePortExchangeCode: 'รหัสแลกเปลี่ยนท่าเรือต้นทาง',
  DestinationPortExchangeCode: 'รหัสแลกเปลี่ยนท่าเรือปลายทาง',
  ServiceCode: 'รหัสบริการ',
  OverseasAgentCode: 'รหัสตัวแทนต่างประเทศ',
  JobNumberjobNo: 'หมายเลขงาน (jobNo)',
  ReceivableOrPayable: 'ลูกหนี้ (RP)',
  Jobyear: 'งาน (ปี)',
  Yearyear: 'ปี (year)',
  Length: 'ความยาว',
  Jobmonth: 'งาน (เดือน)',
  Monthmonth: 'เดือน (month)',
  Dateday: 'วันที่ (day)',
  JobSequenceNumberjobSequence: 'หมายเลขลำดับงาน (jobSequence)',
  RandomLetters: 'สุ่มตัวอักษร',
  SequenceNumbersequence: 'หมายเลขลำดับ (sequence)',
  CustomBusinessTypecustomJobType: 'ประเภทงานที่กำหนดเอง (customJobType)',
  SequenceNumberSettings: 'การตั้งค่าหมายเลขลำดับ',
  NeverResetN: 'ไม่รีเซ็ต (N)',
  ResetByYearY: 'รีเซ็ตตามปี (Y)',
  ResetByMonthM: 'รีเซ็ตตามเดือน (M)',
  ResetByDayD: 'รีเซ็ตตามวัน (D)',
  BusinessDate: 'วันที่ทำธุรกิจ',
  DepartureDate: 'วันที่ออกเรือ',
  ShippingDate: 'วันที่ส่งออก',
  ArrivalDate: 'วันที่ถึงท่าเรือ',
  BranchSequenceNumberIndependent: 'หมายเลขลำดับสาขาอิสระ',
  CustomJobTypeSequenceNumberIndependent: 'หมายเลขลำดับประเภทงานที่กำหนดเองอิสระ',
  PaymentDirectionSerialNo: 'หมายเลขซีเรียลทิศทางการชำระเงินเป็นอิสระ',
  DomesticBill: 'บิลภายในประเทศ',
  DomesticBillNo: 'หมายเลขบิลภายในประเทศ',
  ReceivableAndPayableio: 'รับ-จ่าย (io)',
  BranchConfigurationIndependent: 'การตั้งค่าสาขามีผลบังคับใช้แยกกัน',
  JoiningDeclarationNumberRule: 'กฎหมายเลขใบปิดผนึกเพิ่มเติม',
  TakeBillDateOnYearMonthDay: 'รายปี เดือน วันที่รับบิล t',
  TakeDocumentDateOnYearMonthDay: 'วัน เดือน ปี วันที่ทำรายการ',
  TakeActualPayDateOnYearMonthDay: 'วัน เดือน ปี วันที่รับเงินจริง',
  UseBillDateOnYearMonthDay: 'ใช้วันบิล Statement Bill เป็นตัวควบคุมปี เดือน วัน',
  UseDocumentDateOnYearMonthDay: 'ใช้วันที่ใบแจ้งยอดบัญชีเป็นตัวควบคุมปี เดือน วัน',
  UseActualPayDateOnYearMonthDay: 'ใช้การรับชำระจริงเป็นการควบคุมเครื่องหมายน้ำปี เดือน วัน',
  DomesticStatement: 'ใบแจ้งยอดบัญชีในประเทศ',
  ForeignStatement: 'ใบแจ้งยอดบัญชีต่างประเทศ',
  AddConstant: 'เพิ่มค่าคงที่',
  PleaseToJobNumberSettings: 'โปรดดูการตั้งค่าหมายเลขงาน',
  ConstantCannotBeEmpty: 'ค่าคงที่ไม่สามารถเว้นว่างได้',
  ConstantSpecialCharacters$: 'ค่าคงที่ห้ามมีอักขระพิเศษ $、{、}',
  ConfigurationCannotBeEmpty: 'การตั้งค่าไม่สามารถเว้นว่างได้!',
  LengthExceedsAllowableLength: 'ความยาวเกินที่อนุญาต!',
  ConfigurationExpressionCannotBeEmpty: 'นิพจน์การตั้งค่าไม่สามารถเว้นว่างได้',
  ThereAtLeastOneName: 'ต้องมีชื่อกฎอย่างน้อยหนึ่งรายการ',
  JoiningMustChooseAtItem: 'ต้องเลือกกฎหมายเลขใบปิดผนึกเพิ่มเติมอย่างน้อยหนึ่งรายการ',
  ChangingInTheSystemModification: 'การเปลี่ยนแปลงการตั้งค่าอาจส่งผลต่อการค้นหาข้อมูลประวัติในระบบ ยืนยันการบันทึกการแก้ไขหรือไม่?',
  RuleNameAlreadyExists: 'ชื่อกฎมีอยู่แล้ว',
  SaveFailed: 'บันทึกไม่สำเร็จ',
  AreWantToDeleteRule: 'ยืนยันการลบกฎนี้หรือไม่?',
  Prompt: 'แจ้งเตือน',
  BranchBankAccount: 'บัญชีธนาคารสาขา',
  SetAsDefaultRMBAccount: 'ตั้งเป็นบัญชี RMB เริ่มต้น',
  SetAsDefaultUSDAccount: 'ตั้งเป็นบัญชี USD เริ่มต้น',
  Currency: 'สกุลเงิน',
  Bank: 'ธนาคารที่เปิดบัญชี',
  Abbreviation: 'ชื่อย่อ',
  AccountNumber: 'หมายเลขบัญชี',
  RMBDefaultAccount: 'บัญชี RMB เริ่มต้น',
  USDDefaultAccount: 'บัญชีเริ่มต้น USD',
  BankChineseAddress: 'ที่อยู่ภาษาจีนของธนาคาร',
  BankEnglishAddress: 'ที่อยู่ภาษาอังกฤษของธนาคาร',
  TheItCannotBeAccount: 'บัญชีนี้ไม่ได้ใช้สกุลเงิน RMB จึงไม่สามารถเลือกเป็นบัญชีเริ่มต้น RMB ได้',
  TheItCannotBeAccount2: 'บัญชีนี้ไม่ได้ใช้สกุลเงิน USD จึงไม่สามารถเลือกเป็นบัญชีเริ่มต้น USD ได้',
  NameDoYouWantSave: '] มีชื่ออยู่แล้วจะบันทึกหรือไม่?',
  SaveWantToCloseWindow: 'บันทึกสำเร็จ ต้องการปิดหน้าต่างหรือไม่?',
  CurrencyCannotBeEmpty: 'สกุลเงินไม่สามารถเว้นว่างได้',
  CodeCannotBeEmpty: 'รหัสไม่สามารถเว้นว่างได้',
  EnglishNameCannotBeEmpty: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้',
  AccountNumberCannotBeEmpty: 'หมายเลขบัญชีไม่สามารถเว้นว่างได้',
  TaxControlDiskNumberMaintenance: 'การบำรุงรักษาหมายเลขเครื่องควบคุมภาษี',
  Number: 'หมายเลข',
  InvoiceCode: 'รหัสจุดออกใบแจ้งหนี้',
  UsageDepartment: 'แผนกที่ใช้',
  TheNumberCannotBeRepeated: 'หมายเลขไม่สามารถซ้ำกันได้!',
  InvoiceCodeCannotBeRepeated: 'รหัสจุดออกใบแจ้งหนี้ไม่สามารถซ้ำกันได้!',
  OneToMaintainMultipleNumbers: 'ไม่อนุญาตให้แผนกหนึ่งบำรุงรักษาหมายเลขเครื่องควบคุมภาษีหลายรายการ',
  NumberCannotBeEmpty: 'หมายเลขไม่สามารถเว้นว่างได้!',
  InvoiceCodeCannotBeEmpty: 'รหัสจุดออกใบแจ้งหนี้ไม่สามารถเว้นว่างได้!',
  UsageDepartmentCannotBeEmpty: 'แผนกที่ใช้ไม่สามารถเว้นว่างได้!',
  DepartmentCode: 'รหัสแผนก',
  JobNumberEncodingField: 'ฟิลด์รหัสงาน',
  IsItASettlementCompany: 'เป็นบริษัทชำระเงินหรือไม่',
  AddDepartment: 'เพิ่มแผนก',
  TheOfTheDepartmentEmpty: 'ชื่อแผนกภาษาจีนหรือภาษาอังกฤษไม่สามารถเว้นว่างได้',
  EnabledSuccessfully: 'เปิดใช้งานสำเร็จ!',
  DisabledSuccessfully: 'ปิดใช้งานสำเร็จ!',
  SaveSuccessfully: 'บันทึกสำเร็จ!',
  CompanyCode: 'รหัสบริษัท',
  BranchChineseName: 'ชื่อภาษาจีนของสาขา',
  ChineseAddress: 'ที่อยู่ภาษาจีน',
  BranchEnglishName: 'ชื่อภาษาอังกฤษของสาขา',
  City: 'เมือง',
  PostalCode: 'รหัสไปรษณีย์',
  Fax: 'แฟกซ์',
  Phone: 'โทรศัพท์',
  LocalCurrency: 'สกุลเงินท้องถิ่น',
  DefaultAirport: 'ท่าอากาศยานเริ่มต้น',
  DefaultSeaport: 'ท่าเรือเริ่มต้น',
  SeaBillOfLadingAddress: 'ที่อยู่ใบตราส่งสินค้าทางเรือ',
  AirBillOfLadingAddress: 'ที่อยู่ใบตราส่งสินค้าทางอากาศ',
  RMBAccount: 'บัญชี RMB',
  USDAccount: 'บัญชี USD',
  OverseasBillAddress: 'ที่อยู่ใบแจ้งหนี้ต่างประเทศ',
  DomesticBillAddress: 'ที่อยู่ใบแจ้งหนี้ในประเทศ',
  OverseasEDICode: 'รหัส EDI ต่างประเทศ',
  MarkupTaxRate: 'อัตราภาษีเพิ่มราคา',
  InvoiceTaxRate: 'อัตราภาษีใบแจ้งหนี้',
  SettlementEmail: 'อีเมลชำระเงิน',
  TaxSystemInterfaceAddress: 'ที่อยู่อินเทอร์เฟซระบบภาษี',
  TaxControlPanelNumber: 'หมายเลขแผ่นควบคุมภาษี',
  InvoiceTitle: 'ชื่อในใบแจ้งหนี้',
  InvoiceAddress: 'ที่อยู่ใบแจ้งหนี้',
  TaxpayerIdentificationNumber: 'เลขประจำตัวผู้เสียภาษี',
  ElectronicTicketPlatformCode: 'รหัสแพลตฟอร์มใบแจ้งหนี้อิเล็กทรอนิกส์',
  ElectronicTicketPassword: 'รหัสผ่านใบแจ้งหนี้อิเล็กทรอนิกส์',
  ElectronicTaxpayerIdentificationNumber: 'เลขประจำตัวผู้เสียภาษีใบแจ้งหนี้อิเล็กทรอนิกส์',
  ElectronicTaxpayerAuthorizationCode: 'รหัสอนุญาตผู้เสียภาษีใบแจ้งหนี้อิเล็กทรอนิกส์',
  ElectronicTicketServiceRequestAddress: 'ที่อยู่การร้องขอบริการใบแจ้งหนี้อิเล็กทรอนิกส์',
  InvoiceCancellationRequestAddress: 'ที่อยู่การร้องขอยกเลิกใบแจ้งหนี้',
  RelatedPartners: 'พันธมิตรที่เกี่ยวข้อง',
  EFreighAMSAccount: 'E-Freigh(บัญชี AMS)',
  EFreighACIAccount: 'E-Freigh(บัญชี ACI)',
  CopyCompany: 'คัดลอกบริษัท',
  AddBranch: 'เพิ่มสาขา',
  CopyBranch: 'คัดลอกสาขา',
  BankAccount: 'เลขที่บัญชีธนาคาร',
  SelectFile: 'เลือกไฟล์',
  RemoveFile: 'ลบไฟล์',
  NewBranchInformation: 'ข้อมูลสาขาใหม่',
  N1DepartmentsAndPositionBranch: '1. สิทธิ์การจัดการทั้งหมดของแผนกและตำแหน่งภายใต้สาขานี้ในการจัดการสิทธิ์',
  N2ParameterConfiguration: '2. การกำหนดค่าพารามิเตอร์',
  N3OrderNumberConfiguration: '3. การกำหนดเลขที่เอกสาร',
  Preview: 'ดูตัวอย่าง',
  Apply: 'นำไปใช้',
  CompanyCodeCannotBeEmpty2: 'รหัสบริษัทไม่สามารถเว้นว่างได้',
  TheOfTheCompanyEmpty: 'ชื่อบริษัทภาษาไทยหรืออังกฤษไม่สามารถเว้นว่างได้',
  LocalNotAllowedToEmpty: 'สกุลเงินท้องถิ่นไม่สามารถเว้นว่างได้',
  CopyCompanySucceeded: 'คัดลอกบริษัทสำเร็จ',
  AreYouSureToDelete: 'ยืนยันการลบหรือไม่?',
  DeletedSuccessfully: 'ลบสำเร็จ',
  NameCannotBeEmpty: 'ชื่อไม่สามารถเว้นว่างได้',
  SubmitSuccessfully: 'ส่งสำเร็จ',
  RoleName: 'ชื่อบทบาท',
  PleaseSelect: 'กรุณาเลือก',
  Individual: 'บุคคล',
  DepartmentGroup: 'กลุ่มแผนก',
  BatchAddRolePermissions: 'เพิ่มสิทธิ์บทบาทเป็นชุด',
  UpdatePermissionGroup: 'อัปเดตกลุ่มสิทธิ์',
  Removegtgt: 'ลบ&gt;&gt;',
  ltltAdd: '&lt;&lt;เพิ่ม',
  PermissionName: 'ชื่อสิทธิ์',
  PermissionClass: 'ประเภทสิทธิ์',
  PermissionType: 'รูปแบบสิทธิ์',
  PermissionPoint: 'จุดสิทธิ์',
  Error: 'เกิดข้อผิดพลาด',
  AreDeleteTheCurrentlyRoles: 'ยืนยันการลบรายการที่เลือก',
  PleaseOrMoreRolesDelete: 'กรุณาเลือกบทบาทหนึ่งบทบาทขึ้นไปเพื่อลบ!',
  PleaseOneOrMoreRoles: 'กรุณาเลือกบทบาทหนึ่งบทบาทขึ้นไป',
  PleaseOneOrMorePermissions: 'กรุณาเลือกสิทธิ์หนึ่งรายการหรือมากกว่า',
  BatchAddSuccessfully: 'เพิ่มแบบกลุ่มสำเร็จแล้ว',
  PleaseEnterTheRoleName: 'กรุณากรอกชื่อบทบาท',
  Meaning: 'ความหมาย',
  PleaseEnterTheServiceCode: 'กรุณากรอกรหัสบริการ',
  PleaseTheServiceCodeMeaning: 'กรุณากรอกความหมายรหัสบริการ',
  Defaulted: 'ตั้งเป็นค่าเริ่มต้นแล้ว',
  SetAsDefault: 'ตั้งเป็นค่าเริ่มต้น',
  SuccessSetting: 'ตั้งค่าสำเร็จแล้ว',
  AreToDeleteThisCode: 'ยืนยันที่จะลบรหัสบริการนี้หรือไม่',
  SelectCustomer: 'เลือกลูกค้า',
  PleaseCodeEnglishNameName: 'กรุณากรอกชื่อย่อ รหัส ชื่อภาษาอังกฤษ ชื่อภาษาจีน',
  PleaseSelectACustomer: 'กรุณาเลือกลูกค้า',
  DataCargoTrackingPurchaseEffect: 'บริการส่งข้อมูล: แผนเรือท่าเรือ ข้อมูลตู้สินค้าในท่าเรือ การติดตามสินค้าของบริษัทเรือ การตั้งค่าหน้านี้จะมีผลเมื่อซื้อบริการส่งข้อมูล',
  PushFCLLCLType: 'ประเภทการส่งข้อมูลแบบเต็ม',
  PleaseSelectFCLLCLType: 'กรุณาเลือกประเภทการส่งข้อมูลแบบเต็ม',
  DoServicesNeedToVoyage: 'บริการส่งข้อมูลแผนเรือท่าเรือจำเป็นต้องอัปเดตชื่อเรือและเที่ยวบินหรือไม่',
  IsTrackingLimitedToDeparture: 'การติดตามสินค้าของบริษัทเรือจำกัดท่าเรือต้นทางหรือไม่',
  EnterpriseType: 'ประเภทองค์กร',
  SelectServiceEnabledSelectEffect: 'เลือกทั้งหมดเพื่อตั้งค่าลูกค้าทั้งหมดให้เปิดบริการส่งข้อมูล เลือกบัญชีขาวเพื่อตั้งค่าลูกค้าให้เปิดบริการส่งข้อมูล เลือกบัญชีดำเพื่อตั้งค่าลูกค้าให้ปิดบริการส่งข้อมูล การตั้งค่าจะมีผลตามการบันทึกครั้งล่าสุดเท่านั้น',
  WhiteList: 'บัญชีขาว',
  BlackList: 'บัญชีดำ',
  DeleteConfiguration: 'ลบการตั้งค่า',
  PushCondition: 'เงื่อนไขการส่งข้อมูล',
  MorePushConfiguration: 'การตั้งค่าการส่งข้อมูลเพิ่มเติม...',
  PortPortOfDepartureRange: 'ขอบเขตท่าเรือต้นทางสำหรับการส่งข้อมูลท่าเรือ',
  Shanghai: 'เซี่ยงไฮ้',
  Ningbo: 'หนิงโป',
  Xiamen: 'เซี่ยเหมิน',
  Shenzhen: 'เซินเจิ้น',
  Qingdao: 'ชิงเต่า',
  Tianjin: 'เทียนจิน',
  Fuzhou: 'ฝูโจว',
  Dalian: 'ต้าเหลียน',
  NanSha: 'หนานชา กว่างโจว',
  CustomerList: 'รายชื่อลูกค้า',
  CloseOpen: 'ปิดการตั้งค่าเปิดบริการข้อมูล',
  DataServiceSetting: 'การตั้งค่าบริการข้อมูล',
  DataServiceNotUpdateValue: 'บริการข้อมูลไม่ได้อัปเดตค่าฟิลด์นี้',
  ConditionType: 'ประเภทเงื่อนไข',
  Consignor: 'หน่วยมอบหมาย',
  PleaseSelectConsignor: 'กรุณาเลือกหน่วยมอบหมาย',
  SubscriptionScope: 'ขอบเขตการสมัครสมาชิก',
  NoConfigurationItemsMade: 'ยังไม่ได้ทำการตั้งค่าใดๆ',
  DeletedSuccessfully2: 'ลบสำเร็จแล้ว!',
  FCLLCLTypeNotSelected: 'ยังไม่ได้เลือกประเภทการส่งข้อมูลแบบเต็ม',
  PleaseSelectWhiteListCustomers: 'กรุณาเลือกลูกค้าบัญชีขาว',
  PleaseSelectBlackListCustomers: 'กรุณาเลือกลูกค้าบัญชีดำ',
  SavedSuccessfully: 'บันทึกสำเร็จแล้ว!',
  PleaseLeastOneDataDeletion: 'กรุณาเลือกข้อมูลอย่างน้อยหนึ่งรายการเพื่อลบ!',
  PushServiceProviderConfiguration: 'การตั้งค่าผู้ให้บริการส่งข้อมูล',
  PushServiceName: 'ชื่อบริการส่งข้อมูล',
  ServiceProviders: 'ผู้ให้บริการ',
  ShanghaiPort: 'ท่าเรือเซี่ยงไฮ้',
  ShippingCompanyCargoTracking: 'การติดตามสินค้าของบริษัทเรือ',
  Seabourne: 'ไฮโบ',
  FreighTower: 'เฟยทัว',
  AirCargoTracking: 'การติดตามสินค้าทางเรือ',
  MaritimeDataPush: 'การส่งข้อมูลการขนส่งทางทะเล',
  AirFreightDataPush: 'การส่งข้อมูลการขนส่งทางอากาศ',
  YundangNet: 'ยุนดังเน็ต',
  SeaButler: 'ไฮกวนเจีย',
  NingboPort: 'ท่าเรือหนิงโป',
  XiamenPort: 'ท่าเรือเซี่ยเหมิน',
  QingdaoPort: 'ท่าเรือชิงเต่า',
  FuzhouPort: 'ท่าเรือฝูโจว',
  PortShipSchedule: 'แผนเรือท่าเรือ',
  ShenzhenPort: 'ท่าเรือเซินเจิ้น',
  DalianPort: 'ท่าเรือต้าเหลียน',
  TianjinPort: 'ท่าเรือเทียนจิน',
  DataPushCustomerList: 'รายชื่อลูกค้าที่ได้รับข้อมูล',
  CustomerWhitelist: 'รายชื่อลูกค้าที่อนุญาต:',
  PushContent: 'การตั้งใจเนื้อหาการส่งข้อมูลการขนส่งทางทะเล',
  AirPushContent: 'การตั้งใจเนื้อหาการส่งข้อมูลการขนส่งทางอากาศ',
  PortContainerData: 'ข้อมูลตู้สินค้าในท่าเรือ',
  NoCustomerSelected: 'ยังไม่ได้เลือกลูกค้า',
  UpdateSuccessful: 'อัปเดตสำเร็จ',
  Seaport: 'ท่าเรือทะเล,',
  Airport: 'ท่าอากาศยาน,',
  ChargeItem: 'รายการค่าใช้จ่าย,',
  Route: 'เส้นทางเดินเรือ,',
  Network: 'เครือข่าย,',
  Currency2: 'สกุลเงิน,',
  ContainerType: 'ประเภทตู้,',
  Packaging: 'บรรจุภัณฑ์,',
  BillOfLadingType2: 'ประเภทใบตราส่งสินค้า,',
  CargoType: 'ประเภทสินค้า,',
  TradeTerms: 'ข้อตกลงทางการค้า,',
  TransportTerms: 'ข้อตกลงการขนส่ง,',
  TradeMode: 'วิธีการค้า,',
  AirFreightServiceItems: 'รายการบริการค่าขนส่งทางอากาศ,',
  RelatedPort: 'ท่าเรือที่เกี่ยวข้อง,',
  AirCargoBillMiscellaneous: 'ค่าบริการเพิ่มเติมใบตราส่งสินค้าทางอากาศ,',
  CustomerType: 'ประเภทลูกค้า,',
  BillOfLadingMethod: 'วิธีการออกใบตราส่งสินค้า,',
  CustomBusinessType: 'ประเภทธุรกิจที่กำหนดเอง,',
  CirculatingDocumentType: 'ประเภทเอกสารหมุนเวียน',
  Initialize: 'เริ่มต้น',
  Success: 'สำเร็จ',
  Failure: 'ล้มเหลว',
  AddPort: 'เพิ่มท่าเรือ',
  PleaseSelectPort: 'กรุณาเลือกท่าเรือ',
  Operator: 'ผู้ปฏิบัติงาน',
  PleaseSelectPort2: 'กรุณาเลือกท่าเรือ!',
  PleaseSelectOperator: 'กรุณาเลือกผู้ใช้งานที่เกี่ยวข้อง',
  TheAlreadyMaintainedThisInformation: 'ผู้ใช้งานนี้ได้ตั้งค่าการเชื่อมโยงเรียบร้อยแล้ว',
  PleaseNameEmailEtcQuery: 'กรุณากรอกชื่อจีน ชื่ออังกฤษ อีเมล เพื่อค้นหาแบบเบลอ...',
  NetManagementCode: 'รหัสผู้ดูแลระบบเครือข่าย',
  AfterBeAbleToContinue: 'หากตั้งค่าเป็นยกเลิกการใช้งาน ผู้ใช้จะไม่สามารถเข้าสู่ระบบได้ ต้องการดำเนินการต่อหรือไม่?',
  Valid: 'ใช้งานได้',
  Invalid: 'ยกเลิกการใช้งาน',
  PleaseEnterEmail: 'กรุณากรอกอีเมล',
  EditSuccess: 'แก้ไขสำเร็จ',
  EmailDuplicate: 'อีเมลซ้ำ!',
  UserAllowsInputLettersNumbers: 'รหัสผู้ใช้สามารถกรอกได้เฉพาะตัวอักษรและตัวเลข',
  Operator2: 'ผู้ปฏิบัติงาน:',
  PortCode: 'รหัสท่าเรือ',
  RelatedUser: 'ผู้ใช้งานที่เกี่ยวข้อง',
  BusinessMode: 'รูปแบบธุรกิจ',
  PleaseDataYouWantDelete: 'กรุณาเลือกข้อมูลที่ต้องการลบ',
  AreYouWantToDelete2: 'ยืนยันที่จะลบรายการที่เลือก {0} รายการหรือไม่?',
  DeleteSuccess2: 'ลบสำเร็จ',
  AddRoleUser: 'เพิ่มผู้ใช้งานบทบาทใหม่',
  AddUserWithUnassignedRole: 'เพิ่มผู้ใช้ที่ยังไม่ได้กำหนดบทบาท',
  Query: 'ค้นหา',
  SelectDepartment: 'เลือกแผนก',
  AreYouWantToDelete3: 'ยืนยันที่จะลบหรือไม่?',
  SelectedUsersAlreadyExist: 'ผู้ใช้งานที่เลือกมีอยู่แล้ว',
  AddSuccessfully: 'เพิ่มสำเร็จ',
  CopyRole: 'คัดลอกบทบาท',
  PasteRole: 'วางบทบาท',
  PleaseRoleYouWantCopy: 'กรุณาเลือกบทบาทที่ต้องการคัดลอก!',
  PleaseYouWantToRole: 'กรุณาเลือกแผนกที่ต้องการวางบทบาท!',
  IPWhitelist: 'รายการ IP อนุญาต',
  UserWhitelist: 'รายการผู้ใช้งานอนุญาต',
  JobNumber: 'เลขที่ใบงาน',
  NoteMainAndSplit19: 'หมายเหตุ: เลขที่ใบงานยาวได้สูงสุด 21 หลัก โดย 2 หลักสุดท้ายจะใช้เป็นเครื่องหมายใบงานหลักและใบงานแยก ดังนั้นความยาวของเลขที่ใบงานที่ตั้งค่าในหน้านี้ต้องไม่เกิน 19 หลัก',
  MainOrderNumber: 'เลขที่ใบงานหลัก',
  NoteNumberIsUpLong: 'หมายเหตุ: เลขที่ใบตราส่งสินค้ายาวได้สูงสุด 16 หลัก',
  SubOrderNumber: 'เลขที่ใบงานย่อย',
  NoteIsUpToLong: 'หมายเหตุ: เลขที่ใบงานย่อยยาวได้สูงสุด 21 หลัก',
  WarehouseEntryNumber: 'เลขที่รับเข้าคลัง',
  BookingNumber: 'เลขที่การจองพื้นที่',
  NoteYouHaveSelectedLength: 'หมายเหตุ: เลขที่รับเข้าคลังยาวได้สูงสุด 21 หลัก หากเลือกใช้เลขที่ใบงาน โปรดตรวจสอบความยาวจริง',
  OverseasBillNumber: 'เลขที่บิลต่างประเทศ',
  NoteIsUpToLong2: 'หมายเหตุ: เลขที่บิลต่างประเทศยาวได้สูงสุด 16 หลัก',
  PaymentApplicationForm: 'ใบคำร้องขอชำระเงิน',
  PaymentApprovalForm: 'ใบอนุมัติการชำระเงิน',
  NoteIsUpToLong3: 'หมายเหตุ: เลขที่ใบคำร้องขอชำระเงินยาวได้สูงสุด 16 หลัก',
  NoteIsUpToLong4: 'คำอธิบาย: หมายเลขบิลภายในประเทศยาวสูงสุด 16 หลัก',
  BillOfLadingSerialNumber: 'เลขที่ใบตราส่งสินค้า',
  SeaFreightExport: 'ส่งออกทางทะเล',
  SeaFreightImport: 'นำเข้าทางทะเล',
  AirFreightExport: 'การส่งออกทางอากาศ',
  AirFreightImport: 'การนำเข้าทางอากาศ',
  FBASeaFreight: 'FBA การขนส่งทางทะเล',
  FBAAirFreight: 'FBA การขนส่งทางอากาศ',
  ReportName: 'ชื่อรายงาน',
  Report: 'รายงาน',
  PermissionAddedSuccessfully: 'เพิ่มสิทธิ์สำเร็จ',
  PleaseReportLinkedToRole: 'กรุณาเลือกรายงานที่เกี่ยวข้องกับบทบาท',
  AreToDeleteTheRole: 'ยืนยันที่จะลบบทบาทที่เลือกไว้ในปัจจุบันหรือไม่?',
  PermissionDeletedSuccessfully: 'ลบสิทธิ์สำเร็จ',
  QuickSearchAdTheme: 'ค้นหาด่วน: หัวข้อโฆษณา',
  AdCode: 'เลขที่โฆษณา',
  AdThemename: 'หัวข้อ/ชื่อโฆษณา',
  AdLocation: 'ตำแหน่งโฆษณา',
  BelongsToPage: 'หน้าที่เกี่ยวข้อง',
  BelongsToModule: 'โมดูลที่เกี่ยวข้อง',
  BelongingSystem: 'ระบบที่เกี่ยวข้อง',
  PageViews: 'จำนวนการดู',
  Clicks: 'จำนวนการคลิก',
  ClickRate: 'อัตราการคลิก',
  NumberOfClickUsers: 'จำนวนผู้ใช้ที่คลิก',
  N0FileTypeNotSelected: 'ยังไม่ได้เลือกประเภทไฟล์ {0}',
  NoteCopyFollowingInformation: 'หมายเหตุ: คุณเลือกคัดลอก【{0}】ซึ่งมีข้อมูลดังต่อไปนี้:',
  NXRoles: 'บทบาทหรือไม่?',
  BranchSelection: 'เลือกสาขา',
  CheckParentCompanyWithSubsidiary: 'เลือกบริษัทแม่พร้อมกับบริษัทลูก',
  CurrentlySelectedProject: 'รายการที่เลือกในปัจจุบัน:',
  AlertContentConfiguration: 'การตั้งค่าเนื้อหาเตือนล่วงหน้า',
  AlertTimeConfiguration: 'การตั้งค่าเวลาเตือนล่วงหน้า',
  SopTimeSetUp: 'การตั้งค่าเวลา SOP',
  SetPersonalEmail: 'กรุณาตั้งค่าข้อมูลอีเมลส่วนตัว',
  SetPersonalEmailNote1: 'หลังจากตั้งค่าอีเมลส่วนตัวแล้ว อีเมลผู้ส่งจริงจะเป็นอีเมลส่วนตัวของผู้ใช้แต่ละคน กรุณาตรวจสอบให้แน่ใจว่าผู้ใช้แต่ละคนตั้งค่าอีเมลส่วนตัวถูกต้อง',
  SetPersonalEmailNote2: 'หากตั้งค่าไม่ถูกต้อง จะใช้อีเมลบริษัทและอีเมลระบบเป็นอีเมลผู้ส่งตามลำดับ',
  SetPersonalEmailStep1: 'ขั้นตอนที่ 1: เข้าสู่การตั้งค่าและเครื่องมือ ตั้งค่าอีเมลส่วนตัว',
  SetPersonalEmailStep2: 'ขั้นตอนที่ 2: บำรุงรักษารหัสผ่าน/รหัสอนุญาตของอีเมลส่วนตัว เซิร์ฟเวอร์ผู้ส่ง พอร์ต และข้อมูลลายเซ็น',
  SetPersonalEmailStep3: 'ขั้นตอนที่ 3: หลังจากบันทึกแล้ว สามารถใช้อีเมลส่วนตัวเป็นอีเมลผู้ส่งได้',
  WhtTax: 'โหมดภาษี WHT',
  WhtTaxTip: 'เหมาะสำหรับสถานการณ์ที่มี WHT เช่น ประเทศไทย หลังจากเปิดใช้งานแล้ว ค่าใช้จ่ายสามารถบันทึกการดำเนินการและภาษี WHT การตัดบัญชีสามารถหักภาษี WHT ได้',
  SendDestinationPortProxyDocuments: 'ประวัติไฟล์-ส่งไฟล์ตัวแทนท่าเรือปลายทาง',
  MainTicketAttachmentItem: 'รายการไฟล์แนบตั๋วหลัก',
  SmallTicketAttachmentItem: 'รายการไฟล์แนบตั๋วย่อย',
  SelectFileType: 'เลือกประเภทไฟล์',
  IncludeSlaveAttachLabel: 'เมื่อส่งอีเมลตั๋วหลัก ไฟล์แนบต้องมีไฟล์ตั๋วย่อย',
  AutoGenerationManifestLabel: 'เมื่อไม่มีไฟล์ MANIFEST ในตั๋วหลัก จะพิมพ์อัตโนมัติตามหมายเลขกล่อง',
  FileAttachmentTip: 'หากต้องการตรวจสอบว่ามีไฟล์แนบหรือไม่เมื่อส่ง กรุณาตั้งค่าในการตั้งค่ากฎการตรวจสอบ-การตั้งค่าพื้นฐาน',
  FileAttachmentTip2: 'ระบบจะจับคู่ไฟล์แนบที่เกี่ยวข้องกับวิธี HBL ใบตราส่งโดยอัตโนมัติ สามารถปิดได้ในการจัดการการตั้งค่า-การตั้งค่าพื้นฐาน',
  YearMonthEtdTip: 'ต้องเลือก job(ปี) และ job(เดือน) พร้อมกัน จึงจะนำค่าวันเดือนปีตาม【วันที่ออกเรือ】ที่เลือก',
  YearMonthEtaTip: 'ต้องเลือก job(ปี) และ job(เดือน) พร้อมกัน จึงจะนำค่าวันเดือนปีตาม【วันที่ถึงท่าเรือ】ที่เลือก',
  RiYearMonthEtaTip: 'ต้องเลือก job(ปี) และ job(เดือน) พร้อมกัน จึงจะนำค่าวันเดือนปีตาม【วันที่ถึง】ที่เลือก',
  NotifySuperiors: 'ผู้บังคับบัญชาระดับสูงของพนักงานในตำแหน่ง',
  NotifySuperiorsCheckTip: 'เมื่อเลือก【หัวหน้างานของพนักงาน】ต้องเลือก【ตำแหน่งที่กำหนด】อย่างน้อยหนึ่งตำแหน่ง!',
  AddOnlyCurrentTemplate: 'เพิ่มเฉพาะในเทมเพลตปัจจุบัน',
  AddOtherSameLobTempalte: 'เพิ่มในเทมเพลตอื่นภายใต้ประเภทธุรกิจเดียวกัน',
  OnlyModifyCurrentTemplate: 'แก้ไขเฉพาะแม่แบบปัจจุบันเท่านั้น',
  ModifyTemplateContaneNode: 'แก้ไขเทมเพลตทั้งหมดที่มีโหนดนี้',
  AddRanges: 'ขอบเขตการเพิ่ม',
  ModifyRanges: 'ขอบเขตการแก้ไข',
  ApplicationTemplate: 'ใช้เทมเพลต',
  SetNodeLimitTip: 'เมื่อตั้งค่าโหนด ต้องรักษาความสอดคล้องของ【รหัส】【ชื่อจีน】【ชื่ออังกฤษ】ในโหนด SOP ประเภทธุรกิจเดียวกัน',
  SelectSOPTemplateForNode: 'เลือกเทมเพลต SOP ที่โหนดจะใช้',
  ConfirmJoinSelectTemplate: 'ยืนยันที่จะเพิ่มลงในเทมเพลต SOP ที่เลือกไว้หรือไม่?',
  AddTemplateSameNode: 'เพิ่มในเทมเพลตทั้งหมดที่มีโหนดเดียวกัน',
  ModifyTemplateContinNode: 'แก้ไขเทมเพลตทั้งหมดที่มีสถานะโหนดนี้',
  HblBlWayAttachLabel: 'ดึงไฟล์ HBL ตามวิธีการและประเภทการออกบิลของธุรกิจ',
  HblWithoutGenerateAttachLabel: 'เมื่อไม่มีไฟล์ HBL จะพิมพ์ตัวอย่าง HBL อัตโนมัติ',
  ConfirmedPrintHblLabel: 'เมื่อสถานะ HBL เป็นยืนยันแล้วแต่ยังไม่ออก จะพิมพ์ตัวอย่าง HBL อัตโนมัติ',
  PleaseSetSlaveAttach: 'กรุณาตั้งค่าประเภทไฟล์ของเอกสารแนบใบเสร็จก่อน!',
  QueryFileType: 'ประเภทไฟล์ที่ค้นหา:',
  HblCfmStateOriginDraftLabel: 'เมื่อ HBL ยังไม่ออก เอกสารแนบจะเป็นตัวอย่าง HBL เมื่อออกแล้ว เอกสารแนบจะเป็น HBL',
  BillOfLading: 'เอกสารใบตราส่ง',
  AssociatedRoutesAndPorts: 'เชื่อมโยงเส้นทางเดินเรือและท่าเรือ',
  AirlineChineseName: 'ชื่อเส้นทางเดินเรือ (จีน)',
  PortEnglishName: 'ชื่อท่าเรือ (อังกฤษ)',
  OperationPosition: 'ตำแหน่งปฏิบัติการ',
  UserConfigDuplicate: 'พนักงาน {0} มีข้อมูลการกำหนดค่าอยู่แล้ว กรุณาอย่ากำหนดค่าซ้ำ',
  ConfirmSaveModifiedInfo: 'ยืนยันว่าจะบันทึกข้อมูลที่แก้ไขหรือไม่?',
  PleaseSelectARoute: 'กรุณาเลือกเส้นทางเดินเรือ',
  AssociatedPermissions: 'สิทธิ์ที่เกี่ยวข้อง',
  OptionalPositionsRoles: 'ตำแหน่งรับผิดชอบที่เลือกได้จำกัดตามบทบาทผู้ใช้',
  ResponsiblePosition: 'ตำแหน่งรับผิดชอบ',
  SelectResponsiblePosition: 'กรุณาเลือกตำแหน่งรับผิดชอบ!',
  ConfigApplyRemoteBooking: 'กำหนดค่าใช้กับโมดูลการจองพื้นที่จากระยะไกล',
  AssociatedWarehouseSupplier: 'เชื่อมโยงผู้จัดหาคลังสินค้า',
  WarehouseNameCustomsBrokeDestinationAgent: 'กรุณาเลือกรายการกำหนดค่าที่เกี่ยวข้อง (ชื่อคลังสินค้า, ศุลกากร, ตัวแทนท่าเรือปลายทาง)',
  RelatedCustomsBroker: 'เชื่อมโยงบริษัทศุลกากร',
  RelatedDestinationAgent: 'เชื่อมโยงตัวแทนท่าเรือปลายทาง',
  AssociatedWarehouseName: 'เชื่อมโยงชื่อคลังสินค้า',
  PortCodeRepeat: 'ท่าเรือ {0} มีการตั้งค่าที่เกี่ยวข้องอยู่แล้ว กรุณาอย่าซ้ำ',
  RegionCodeRepeat: 'เส้นทางเดินเรือ {0} มีการตั้งค่าที่เกี่ยวข้องอยู่แล้ว กรุณาอย่าซ้ำ',
  DesignatedCargoControlRange: 'ขอบเขตการควบคุมสินค้าที่กำหนด:',
  RangeOfSelfPickupControl: 'ขอบเขตการควบคุมสินค้าที่รับมาเอง:',
  WarningConfiguration: 'การกำหนดค่าการแจ้งเตือน:',
  AccountsReceivableSettlementUnits: 'หน่วยชำระค่าธรรมเนียมที่ต้องได้รับทั้งหมด',
  DeletePrompt: 'ยืนยันที่จะลบบัญชีนี้หรือไม่? ได้แจ้ง CloudDang ว่าบัญชีนี้ถูกยกเลิกแล้วหรือยัง?',
  EditUser: 'แก้ไขผู้ใช้',
  NewUser: 'เพิ่มผู้ใช้',
  Password: 'รหัสผ่าน',
  CustomerName: 'ชื่อลูกค้า',
  AccountMaintenance: 'บำรุงรักษาบัญชีการเรียกใช้ API',
  Unmaintained: 'คุณไม่ได้ให้บัญชีและรหัสผ่าน จึงไม่สามารถสมัครรับข้อมูลท่าเรือได้ กรุณาติดต่อฝ่ายบริการลูกค้า',
  PortNotNull: 'ท่าเรือไม่สามารถเว้นว่างได้',
  CustomerNotNull: 'ชื่อลูกค้าไม่สามารถเว้นว่างได้',
  AccountNumberNotNull: 'บัญชีผู้ใช้ไม่สามารถเว้นว่างได้',
  PasswordNotNull: 'รหัสผ่านไม่สามารถเว้นว่างได้',
  CustomIdNotNull: 'customId ไม่สามารถเว้นว่างได้',
  PartnerWarehouseCode: 'รหัสหมายเลขคลังสินค้าของพาร์ทเนอร์',
  PartnerWarehouseCodeTip: 'เมื่อหน่วยผู้ว่าจ้าง ตัวแทนขนส่งที่กำหนด และตัวแทนท่าเรือปลายทางในเอกสารธุรกิจตั้งค่ารหัสหมายเลขคลังสินค้า สามารถกำหนดลำดับความสำคัญในการดึงค่าได้',
  MailServer: 'เซิร์ฟเวอร์อีเมล',
  MailServerConfigTip: 'ต้องตั้งค่าอีเมลบริษัทและเปิดใช้งานใน【บริการกำหนดค่าการ推送】ก่อน',
  PushConfigServiceCompanyEmail: 'ต้องตั้งค่าอีเมลบริษัทและเปิดใช้งานใน【บริการกำหนดค่าการผลักดัน】ก่อน',
  PushConfigServicePersonalEmail: 'กรุณาเลือกอีเมลส่วนบุคคลของตำแหน่งที่กำหนดหรือบุคคลที่กำหนด ต้องตั้งค่าอีเมลส่วนบุคคลและเปิดใช้งานก่อนใช้',
  SelectSendEmail: 'เลือกอีเมลผู้ส่ง',
  Assigner: 'บุคคลที่กำหนด',
  ConfigEmailForNode: 'กำหนดวิธีการส่งอีเมลสำหรับโหนดนี้',
  MultipleTriggers: 'ทริกเกอร์หลายครั้ง',
  IsMultipleTriggers: 'ไม่ว่าจะเป็นความจำเป็นทริกเกอร์หลายครั้ง',
  AllowTriggeringAgainValueChange: 'อนุญาตให้ทริกเกอร์อีกครั้งเมื่อค่าฟิลด์เปลี่ยนแปลง',
  OnlyEntityCodeSupportTrigger: 'เฉพาะฟิลด์ประเภทวันที่และสตริงที่มีรหัสเอนทิตีเป็น Job / AirExportJob / AirlmportJob / IntegratedJob /SeaExportJob / Sealmportjob ที่รองรับการทริกเกอร์หลายครั้ง กรุณายืนยันกับทีมพัฒนาก่อน!',
  TriggerTypeChangePushMsg: 'ผลักดันข้อความอีกครั้งเมื่อค่าประเภททริกเกอร์เปลี่ยนแปลง',
  CheckBaseLabel: 'ผลักดันเฉพาะตามผู้ติดต่อที่ตั้งค่าในเอกสารธุรกิจ',
  PushExternalInterfaces: 'ผลักดันอินเทอร์เฟซภายนอก',
  TriggerInternalEvent: 'ทริกเกอร์เหตุการณ์ภายใน',
  TriggerTypeChangePushInterface: 'ผลักดันอินเทอร์เฟซอีกครั้งเมื่อค่าประเภททริกเกอร์เปลี่ยนแปลง',
  XhqBillDataUpdate: 'อัปเดตข้อมูลบิลของลายเซ็น Signal Flag',
  msdBillDataUpdate: 'API การส่งข้อมูลบิล MSD',
  MsdApiLog: 'บันทึก API MSD',
  canPushPreConfiguration: 'สามารถพุชการกำหนดค่าล่วงหน้าได้',
  pushPreConfiguredInformation: 'ส่งข้อมูลที่กำหนดค่าไว้ล่วงหน้า',
  pushMasterData: 'ส่งข้อมูลทั้งหมดภายใต้ใบตราส่งหลักปัจจุบันเป็นข้อมูลการกำหนดค่าล่วงหน้า หลังการตรวจสอบ โปรดคลิก "ยืนยัน"',
  AgainPushTitleDisplay: 'หัวข้ออีเมลที่ผลักดันอีกครั้งจะแสดงการเปลี่ยนแปลงของค่าประเภททริกเกอร์ เช่น: ข้อความการจองเรือ【ชื่อเรือและเที่ยวขาออก】เดิม: SITC → ปัจจุบัน: LECANGS; เดิม: V.088W → ปัจจุบัน: 0XSJXS',
  CheckRuleToAllBranch: 'กฎการตรวจสอบมีผลกับทุกสาขา',
  CustomDescription: 'คำอธิบายที่กำหนดเอง',
  OnlyPositiveFeePermission: 'ไม่มีสิทธิ์ดำเนินการ สามารถเพิ่มค่าใช้จ่ายที่เป็นบวกเท่านั้น',
  PleaseSelectOpBranch: 'กรุณาเลือกสาขาที่จะดำเนินการ!',
  OpOfficeChangeUpdateData: 'แก้ไขสาขาดำเนินการแล้ว ต้องการอัปเดตบุคลากรในตำแหน่งที่เกี่ยวข้องหรือไม่?',
  WarehouseChangeUpdateData: 'แก้ไขสาขาดำเนินการแล้ว ต้องการอัปเดตคลังสินค้า/บริษัทศุลกากร/ตัวแทนท่าเรือปลายทางที่เกี่ยวข้องหรือไม่?',
  ClassifyName: 'ชื่อหมวดหมู่',
  Sort: 'เรียงล.',
  ClassifyMsgNameEmpty: 'ต้องกรอกชื่อหมวดหมู่',
  ClassifyMsgSortEmpty: 'ต้องกรอกการเรียงลำดับ',
  ClassifyMsgNameRepeat: 'ชื่อหมวดหมู่ห้ามซ้ำ',
  ClassifyMsgSortRepeat: 'หมายเลขเรียงลำดับห้ามซ้ำ',
  ConfirmDeletionOfClassifyMsg: 'ยืนยันที่จะลบหมวดหมู่ข้อความนี้หรือไม่? จะลบเวอร์ชันจีน อังกฤษ และญี่ปุ่นที่เกี่ยวข้องพร้อมกัน!',
  ClassifyMsgDeletedTips: 'มีข้อความแจ้งเตือนในหมวดหมู่นี้ ไม่สามารถลบได้!',
  MsgTitle: 'หัวข้อข้อความ',
  Content: 'เนื้อความ',
  ConfirmDeletionOfBellMsg: 'ยืนยันที่จะลบข้อความแจ้งเตือนนี้หรือไม่? จะลบเวอร์ชันจีน อังกฤษ และญี่ปุ่นที่เกี่ยวข้องพร้อมกัน!',
  BellMsgTitleEmpty: 'ต้องกรอกหัวข้อข้อความ',
  BellMsgCodeEmpty: 'ต้องกรอกรหัส',
  BellMsgContentEmpty: 'ต้องกรอกเนื้อความ',
  BellMsgTitleRepeat: 'หัวข้อข้อความห้ามซ้ำ',
  BellMsgCodeRepeat: 'รหัสห้ามซ้ำ',
  BellMsgContentRepeat: 'เนื้อความห้ามซ้ำ',
  Language: 'ภาษา',
  Link: 'ที่อยู่สำหรับกระโดด',
  LinkTip: 'เส้นทางกระโดดใช้สำหรับการกระโดดไปยังอินเทอร์เฟซการดำเนินการที่เกี่ยวข้อง กรุณายืนยันกับทีมพัฒนาก่อนกรอก!',
  BellSubscriptionTitle: 'การตั้งค่าการสมัครรับข้อความ',
  BellSubscriptionConf: 'การสมัครรับข้อความแจ้งเตือน',
  BellSubscribed: 'สมัครรับแล้ว',
  BellUnSubscribed: 'ยังไม่ได้สมัครรับ',
  MessageConfig: 'การตั้งค่าข้อความ',
  WoBaoIntelligentAssistant: 'ผู้ช่วยอัจฉริยะโวเบา',
  WoBaoSubscriptionTip: 'ผู้ช่วยอัจฉริยะโวเบาจะแจ้งเตือนข้อความที่ยังไม่ได้อ่านของวันนี้ที่คุณสมัครรับไว้บนหน้าเว็บ',
  AllMessage: 'ข้อความทั้งหมด',
  TodayUnReadMsg: 'ข้อความที่ยังไม่ได้อ่านวันนี้',
  ViewHQMapping: 'ดูการแมป HQ',
  BranchNotMatchNotOperate: 'ไม่ใช่ข้อมูลของสาขานี้ ไม่สามารถดำเนินการได้',
  UsersAlertNotifyAfterUsingXX: 'ผู้ใช้สามารถตั้งค่าการแจ้งเตือนล่วงหน้าเมื่อใช้งานไปแล้ว XX%',
  UsersAlertNotifyBeforeExpireDate: 'ผู้ใช้สามารถตั้งค่าการแจ้งเตือนล่วงหน้า XX วันก่อนถึงวันหมดอายุ',
  UnloadingEortEnName: 'ชื่อภาษาอังกฤษของท่าขนถ่ายสินค้า',
  OriginPortEnName: 'ชื่อภาษาอังกฤษของท่าเรือต้นทาง',
  MatchingCriteriaSelection: 'การเลือกเงื่อนไขการจับคู่',
  PresetValueConfiguration: 'การกำหนดค่าล่วงหน้า',
  MatchingCriteriaSelectionTip: 'ใช้สำหรับการจับคู่ในเอกสารทางธุรกิจ เมื่อตรงตามเงื่อนไขการจับคู่ จะมีการกรอกค่าล่วงหน้าโดยอัตโนมัติ',
  PresetValueConfigurationTip: 'การส่งออกทางทะเลคำนวณจำนวนวันที่ล่วงหน้าตาม ETD โดยชดเชยวันหยุดสุดสัปดาห์โดยอัตโนมัติ หากจำนวนวันเป็น 0 หมายถึงไม่มีการคำนวณวันที่เกี่ยวข้องโดยอัตโนมัติ',
  PleaseSelectDeparturePort: 'กรุณาเลือกท่าเรือต้นทาง',
  PleaseSelectUnloadingPort: 'กรุณาเลือกท่าขนถ่ายสินค้า',
  PleaseSelectCarrier: 'กรุณาเลือกผู้ขนส่ง',
  PortRequirementBillRequirements: 'ข้อกำหนดของท่าเรือ (ข้อกำหนดใบตราส่งสินค้า)',
  PleaseSaveCurrentDataFirst: 'กรุณาบันทึกข้อมูลปัจจุบันก่อน',
  RelatedInstructionsAttachments: 'ไฟล์แนบคำอธิบายที่เกี่ยวข้อง',
  PortRequirementsRelatedDocuments: 'เอกสารที่เกี่ยวข้องกับข้อกำหนดของท่าเรือ',
  NoRelevantDocumentsAvailable: 'ไม่มีเอกสารที่เกี่ยวข้อง',
  DefaultConfigurationNotes: 'หมายเหตุการกำหนดค่าล่วงหน้า',
  PleaseSelectMatchingItem: 'กรุณาเลือกรายการที่ตรงกัน',
  CalculateDateIncludeETDTheDay: 'การคำนวณจำนวนวันที่ล่วงหน้ารวมถึงวัน ETD ด้วย',
  SetLeadTimeBasedOnETDTime: 'ตั้งค่าจำนวนวันที่ล่วงหน้าตามเวลา ETD',
  PleaseSetPreset: 'กรุณาตั้งค่ารายการล่วงหน้า',
  WoBaoSubscribed: 'เปิดใช้งานแล้ว',
  WoBaoUnSubscribed: 'ปิดใช้งานแล้ว',
  CalculateIncludeEtdIsWeekend: 'การคำนวณจำนวนวันที่ล่วงหน้ารวมถึงกรณีที่ ETD เป็นวันหยุดสุดสัปดาห์',
  PositionAssociatedRoutePortConfig: 'การกำหนดค่าล่วงหน้าของเส้นทาง/ท่าเรือที่เกี่ยวข้องกับบุคลากรในตำแหน่งงาน',
  PleaseSelectLoadingPort: 'กรุณาเลือกท่าเรือบรรทุกสินค้า',
  PleaseSelectOriginatingStation: 'กรุณาเลือกสถานีต้นทาง',
  PleaseSelectDestinationStation: 'กรุณาเลือกสถานีปลายทาง',
  PositionCannotDuplicated: 'ตำแหน่งงานไม่สามารถซ้ำกันได้',
  UserHasRepeatConfigData: 'ผู้ใช้นี้มีข้อมูลการกำหนดค่าที่ซ้ำกันแล้ว!',
  UserRoleDefaultRepeat: 'มีพนักงานคนอื่นกำหนดค่าเริ่มต้นของตำแหน่งงานที่ตรงกับเงื่อนไขนี้แล้ว ยืนยันที่จะแก้ไขหรือไม่?',
  ChartSource: 'แหล่งที่มาของแผนภูมิ',
  EnterChartSource: 'กรุณาเลือกแหล่งที่มาของแผนภูมิ',
  ToDoNodeRuleSettings: 'การตั้งค่ากฎของโหนดงานที่ต้องทำ',
  ServiceScenarioApplication: 'กฎทางธุรกิจเฉพาะ',
  SettingApplicationScenarios: 'การตั้งค่ากฎทางธุรกิจ',
  OperationButtonSettings: 'การตั้งค่าปุ่มดำเนินการ',
  ButtonName: 'ชื่อปุ่ม',
  MainNotToDoTask: 'เอกสารหลักไม่ถือเป็นงานที่ต้องทำ (กรณีการรวมตู้)',
  SpecifyRole: 'ระบุบทบาท',
  CheckPrivilegePersonLabel: 'จำกัดบทบาทที่ไม่มีสิทธิ์ประเภทในการแก้ไขประเภทไฟล์หรือไม่',
  SetExclusionOffices: 'ตั้งค่าสาขาที่ได้รับการยกเว้น',
  AccountsReceivable: 'ค่าบริการที่ต้องรับ',
  Just: 'และ',
  NotEntityCompany: 'บริษัทที่ไม่ใช่นิติบุคคล',
  NotEntityCompanyTip: 'เมื่อทำสถิติรายงานทางการเงินเฉพาะ ต้องทำเครื่องหมายในช่องนี้',
  Marked: 'ติดป้ายกำกับ',
  NotSetDefaultValueMultiPosition: 'เมื่อเงื่อนไขตรงกับพนักงานหลายตำแหน่ง จะไม่แสดงค่าดีฟอลต์ ต้องเลือกด้วยตนเอง!',
  AvailableOfficeOverMaxLimit: 'จำนวนสาขาที่ใช้ได้ถึงขีดจำกัดแล้ว หากต้องการเพิ่มจำนวนสาขา สามารถติดต่อฝ่ายขายหรือบริการลูกค้า',
  AvailableUserOverMaxLimit: 'จำนวนผู้ใช้ที่ใช้ได้ถึงขีดจำกัดแล้ว หากต้องการเพิ่มจำนวนผู้ใช้ สามารถติดต่อฝ่ายขายหรือบริการลูกค้า',
  BranchCountExpireLimitUse: 'เรียนผู้ใช้งาน การขยายสาขาที่ท่านซื้อหมดอายุแล้ว<br>กรุณาต่ออายุเพื่อใช้งานต่อ สามารถติดต่อฝ่ายขายหรือบริการลูกค้า<br><div style="margin-top: 5px;">ขณะนี้สาขาจะถูกจำกัดการเข้าถึง แต่ข้อมูลจะยังคงอยู่ เมื่อต่ออายุแล้วจะสามารถใช้งานได้อีกครั้ง</div>',
  UserCountExpireLimitUse: 'เรียนผู้ใช้งาน การขยายจำนวนผู้ใช้ที่ท่านซื้อหมดอายุแล้ว<br>กรุณาต่ออายุเพื่อใช้งานต่อ สามารถติดต่อฝ่ายขายหรือบริการลูกค้า<br><div style="margin-top: 5px;">ขณะนี้ผู้ใช้จะถูกระงับการใช้งาน แต่ข้อมูลจะยังคงอยู่ เมื่อต่ออายุแล้วจะสามารถเปิดใช้งานได้อีกครั้ง</div>',
  UserCountExpireLimitAdmin: 'เรียนผู้ใช้งาน การขยายจำนวนผู้ใช้ที่ท่านซื้อหมดอายุแล้ว<br>กรุณาต่ออายุเพื่อใช้งานต่อ สามารถติดต่อฝ่ายขายหรือบริการลูกค้า<br><div style="margin-top: 5px;">ขณะนี้ผู้ใช้ (ยกเว้นผู้ดูแลระบบ) จะถูกระงับการใช้งาน แต่ข้อมูลจะยังคงอยู่ เมื่อต่ออายุแล้วจะสามารถเปิดใช้งานได้อีกครั้ง</div>',
  OpenConfig: 'เปิดใช้งานรายการกำหนดค่า',
  SendType: 'โหมดการส่ง',
  Key: 'คีย์ลับ',
  UserPwd: 'รหัสผ่านบัญชี',
  OpenConfigTip: 'เมื่อเปิดใช้งาน เทมเพลตนี้จะส่งตาม {0} ที่กำหนดค่าไว้',
  NotEmptyTips: 'ช่องสีฟ้าเป็นช่องที่ต้องกรอก!',
  MustBeNumericType: '{0} ต้องเป็นประเภทตัวเลข',
  MainTicket: 'ตั๋วหลัก',
  SlaveTicket: 'ตั๋วย่อย',
  Alias: 'ชื่ออื่น',
  SetAlias: 'ตั้งค่าชื่อเรียกอื่น',
  AliasOnlyHQ: 'การตั้งชื่อเรียกอื่นจะตั้งค่าแบบรวมที่สำนักงานใหญ่เท่านั้น',
  HideCategoryAllLanguage: 'ซ่อนหมวดหมู่นี้ (ใช้กับทุกภาษาที่รองรับ)',
  FieldDisplayHideForbid: 'เมื่อมีฟิลด์ที่แสดงสถานะในหมวดหมู่ จะไม่สามารถซ่อนได้!',
  SetBlockWidth: 'ตั้งค่าความกว้างบล็อก',
  SettableRange300400: 'ช่วงที่สามารถตั้งค่าได้: 300-400',
  HQSavePrompt: 'คำเตือนการบันทึกของสำนักงานใหญ่',
  BranchSavePrompt: 'คำเตือนการบันทึกของสาขา',
  OnlyDisplayMandatoryRule: 'ปรับเฉพาะกฎการแสดงและบังคับกรอกฟิลด์ ไม่ทับลำดับการแสดงฟิลด์ในหน้าคำสั่งกำหนดเองของสาขาและพนักงาน!',
  DisplayMandatorySort: 'ปรับกฎการแสดงและบังคับกรอกฟิลด์ และรีเซ็ตลำดับการแสดงฟิลด์ในหน้าคำสั่งกำหนดเองของสาขาและพนักงานตามกฎของสำนักงานใหญ่!',
  AdjustOrderConfig: 'รายการนี้จะทำให้ลำดับอินเทอร์เฟซที่กำหนดไว้ทั้งหมดของสาขาและพนักงานถูกปรับตามลำดับการตั้งค่าของสำนักงานใหญ่!',
  OfficeOnlyDisplayMandatoryRule: 'ปรับเฉพาะกฎการแสดงและบังคับกรอกฟิลด์ ไม่ทับลำดับการแสดงฟิลด์ในหน้าคำสั่งกำหนดเองของพนักงาน!',
  OfficeDisplayMandatorySort: 'ปรับกฎการแสดงและบังคับกรอกฟิลด์ และรีเซ็ตลำดับการแสดงฟิลด์ในหน้าคำสั่งกำหนดเองของพนักงานตามกฎของสาขา!',
  OfficeAdjustOrderConfig: 'รายการนี้จะทำให้ลำดับอินเทอร์เฟซที่กำหนดไว้ของพนักงานถูกปรับตามลำดับการตั้งค่าของสาขา!',
  ApplyHQSetting: 'ยืนยันว่าจะใช้การตั้งค่าของบริษัทแม่หรือไม่?',
  ResetCustomSetConfirm: 'ยืนยันที่จะรีเซ็ตการตั้งค่าที่กำหนดเองของแท็บนี้หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้ โปรดยืนยัน!',
  HQSettingNotEditAlias: 'เมื่อใช้การตั้งค่าของสำนักงานใหญ่ สาขาไม่สามารถแก้ไขปรับแต่งได้ การตั้งชื่อเรียกอื่นจะตั้งค่าแบบรวมที่สำนักงานใหญ่เท่านั้น',
  NonLoginUser: 'ผู้ใช้ที่ไม่เข้าสู่ระบบ',
  ValidUserNotNeedLogin: 'ผู้ใช้ที่มีผลซึ่งไม่จำเป็นต้องเข้าสู่ระบบ',
  NotLoginUserContactAdmin: 'ผู้ดูแลระบบได้ตั้งค่าท่านเป็นผู้ใช้ที่ไม่จำเป็นต้องเข้าสู่ระบบ หากต้องการใช้งานระบบ โปรดติดต่อผู้ดูแลระบบเพื่อปรับเปลี่ยนแล้วเข้าสู่ระบบใหม่',
  FinanceExpireLimitUse: 'เรียนผู้ใช้งาน โมดูลการจัดการการเงินที่ท่านซื้อหมดอายุแล้ว<br>กรุณาต่ออายุเพื่อใช้งานต่อ สามารถติดต่อฝ่ายขายหรือบริการลูกค้า<br><div style="margin-top: 5px;">โมดูลการจัดการการเงินจะถูกจำกัดการเข้าถึง แต่ข้อมูลจะยังคงอยู่ เมื่อต่ออายุแล้วจะสามารถใช้งานได้อีกครั้ง</div>',
  EdiExpireLimitUse: 'เรียนผู้ใช้งาน อินเทอร์เฟซ EDI การจองที่ท่านซื้อหมดอายุแล้ว<br>กรุณาต่ออายุเพื่อใช้งานต่อ สามารถติดต่อฝ่ายขายหรือบริการลูกค้า',
  TaxExpireLimitUse: 'เรียนผู้ใช้งาน ท่านยังไม่ได้เปิดใช้บริการควบคุมภาษี หรือบริการควบคุมภาษีที่ซื้อหมดอายุแล้ว<br>กรุณาต่ออายุเพื่อใช้งานต่อ สามารถติดต่อฝ่ายขายหรือบริการลูกค้า',
  EntrustPageTab: 'แท็บมอบหมาย',
  ExportEntrustPageTab: 'แท็บมอบหมายส่งออก',
  ImportEntrustPageTab: 'แท็บมอบหมายนำเข้า',
  AttachmentRuleConfig: 'การกำหนดค่ากฎไฟล์แนบ',
  BusinessOrdersAttachments: 'เมื่อธุรกิจมีใบแยกรูปแบบ ไฟล์แนบจะดึงข้อมูลจากใบแยกรูปแบบ',
  SendPackageProxyFiles: 'ประวัติไฟล์ - ส่งไฟล์ชุดเอกสารตัวแทน',
  BillNotStartNoneFile: 'เมื่อสถานะใบตราส่ง HBL ยังไม่เริ่มหรือรอการยืนยัน จะไม่ดึงไฟล์ใบตราส่งใดๆ (รวมถึงตัวอย่าง)',
  LockAfterSend: 'ล็อกหลังส่ง:',
  SendLockSlaveHblAndVirtualBill: 'หลังส่ง ให้ล็อกแท็บ HBL และแท็บแบ่งใบตราส่งแบบฟอร์มของใบเสร็จ (รวมถึงการแยก/รวมใบสั่ง)',
  SendLockExchangeAgentHblAndVirtualBill: 'หลังส่ง ให้ล็อกแท็บ HBL และแท็บแบ่งใบตราส่งแบบฟอร์มของตัวแทนเปลี่ยนใบตราส่งที่เกี่ยวข้อง (รวมถึงการแยก/รวมใบสั่ง)',
  AutoPrintManifestAfterAllHblConfirm: 'พิมพ์ไฟล์ MANIFEST อัตโนมัติเฉพาะเมื่อสถานะใบตราส่ง HBL ทั้งหมดได้รับการยืนยันแล้ว (รวมถึงการแยกใบสั่ง HBL)',
  BusinessDataNotUpdate: 'เมื่ออัปเดตข้อมูลธุรกิจ จะไม่อัปเดตบุคลากรในตำแหน่งงานโดยอัตโนมัติ',
  AutoPrintRule: 'กฎการพิมพ์อัตโนมัติ',
  EmailAttachRule: 'กฎการดึงไฟล์แนบอีเมล',
  FormalDivisionRule: 'กฎการแบ่งใบตราส่งแบบฟอร์ม',
  BusinessIfVirtualBillOnlyAttachment: 'เมื่อธุรกิจมีใบแบ่งแบบฟอร์ม ไฟล์แนบจะดึงเฉพาะไฟล์ใบแบ่งแบบฟอร์ม',
  SetFileSyncRule: 'ตั้งค่ากฎการซิงค์ไฟล์',
  BusinessModel: 'รูปแบบธุรกิจ:',
  SyncDirection: 'ทิศทางการซิงค์:',
  SyncCondition: 'เงื่อนไขการซิงค์',
  SyncFileToApprovedDoc: 'สามารถซิงค์ไฟล์ไปยังเอกสารที่อนุมัติแล้ว',
  DeleteFile: 'ลบไฟล์:',
  SyncMode: 'โหมดซิงค์:',
  CrossDelegation: 'มอบหมายงานข้าม',
  PrincipalOperator: 'ผู้มอบหมาย -> ผู้ดำเนินการ',
  OperatorClient: 'ผู้ดำเนินการ -> ผู้มอบหมาย',
  SyncFileDeletion: 'ซิงค์การลบไฟล์',
  NotDeleteRelateFile: 'ไม่ลบไฟล์ของอีกฝ่าย',
  ManualSync: 'ซิงค์แบบมือถือ',
  AutoSync: 'ซิงค์อัตโนมัติ',
  ExportToImport: 'ส่งออกเปลี่ยนเป็นนำเข้า',
  ExporterImporter: 'ผู้ส่งออก -> ผู้นำเข้า',
  ImporterExporter: 'ผู้นำเข้า -> ผู้ส่งออก',
  BbSendDestinationPortAgent: 'มอบหมายให้ส่งไฟล์ตัวแทนท่าเรือปลายทางแบบรวมตู้',
  ChargeSyncAuditPass: 'ปรับเทียบค่าใช้จ่าย - ตรวจสอบผ่าน',
  ChargeSyncAuditNotPass: 'การประสานค่าใช้จ่าย - การตรวจสอบไม่ผ่าน',
  ChargeSyncRecallApplyCharge: 'ปรับเทียบข้อมูล - ถอนค่าธรรมเนียมการสมัคร',
  SendEmailByPositionPersonnel: 'จดหมายจะถูกส่งต่อไปยังผู้ส่ง ที่ตั้งค่าไว้',
  AttachmentItems: 'รายการไฟล์แนบ',
  PleaseSetAttach: 'กรุณาตั้งค่าประเภทไฟล์ของรายการไฟล์แนบก่อน!',
  SendLockHblAndVirtualBill: 'หลังส่ง ให้ล็อกแท็บ HBL และแท็บแบ่งใบตราส่งแบบฟอร์มของธุรกิจ (รวมถึงการแยก/รวมใบสั่ง)',
  AirOperationTAB: 'แท็บการดำเนินการขนส่งทางอากาศ',
  CurrentPageNewFieldTip: 'แท็บปัจจุบันมีฟิลด์ใหม่ กรุณาคลิกแก้ไขแล้วเพิ่มฟิลด์',
  SystemAddedItem: 'รายการฟิลด์ใหม่ของระบบ',
  DragTheBlockUse: 'กรุณาลากฟิลด์ไปไว้ใต้บล็อกหมวดหมู่ที่เกี่ยวข้องจึงจะใช้งานได้',
  CustomTemplateMustSelect: 'ชื่อเทมเพลตที่กำหนดเองต้องเลือกข้อมูลอย่างน้อยหนึ่งรายการ',
  VirtualBillHBLNO: 'หมายเลข HB/L ของใบแบ่งแบบฟอร์ม',
  TemplateRemarks: 'หมายเหตุเทมเพลต',
  AutomPrintDefaultFileType: 'ประเภทไฟล์เริ่มต้นสำหรับการพิมพ์อัตโนมัติ',
  PopupMode: 'โหมดป๊อปอัพ',
  DisplayWhenThereIsValidation: 'แสดงป๊อปอัพข้อมูลการตรวจสอบเฉพาะเมื่อมีข้อมูลข้อผิดพลาดในการตรวจสอบ',
  TheBeAppliedToOffices: 'โหมดป๊อปอัพจะถูกนำไปใช้กับทุกสาขา',
  VerificationNodeCannotBeEmpty: '【โหนดตรวจสอบ】ไม่สามารถเว้นว่างได้',
  VerificationModeCannotBeEmpty: '【โหมดตรวจสอบ】ไม่สามารถเว้นว่างได้',
  CustomerOfLadingOptionIssue: 'ลูกค้าออกใบตราส่งเอง (เลือกที่ลูกค้าออกใบตราส่งเองในใบตราส่ง)',
  WhenLadingHasBeenDocuments: 'เมื่อมีไฟล์ลูกค้าออกใบตราส่งเอง และใบตราส่งได้รับการยืนยันหรือออกแล้ว ให้ดึงใบตราส่งที่ลูกค้าออกเอง',
  WhenIsNeitherConfirmedExtracted: 'เมื่อมีไฟล์ลูกค้าออกใบตราส่งเอง แต่ใบตราส่งยังไม่ได้รับการยืนยันหรือยังไม่ออก จะไม่ดึงใบตราส่งที่ลูกค้าออกเอง',
  WhenOfLadingHasSample: 'เมื่อไม่มีไฟล์ลูกค้าออกใบตราส่งเอง และใบตราส่งได้รับการยืนยันแต่ยังไม่ออก จะพิมพ์ตัวอย่างโดยอัตโนมัติ',
  ApplicationModule: 'โมดูลแอปพลิเคชัน',
  UICustomisation: 'กำหนดค่า UI เอง',
  SOPPanel: 'แผง SOP',
  FileHistoryTab: 'แท็บประวัติไฟล์',
  ViewOpInstruction: 'ดูคำสั่งการทำงาน',
  SetOpInstruction: 'ตั้งค่าคำสั่งการทำงาน',
  HeadquartersSetupForCommandApplications: 'การตั้งค่าบริษัทแม่สำหรับการใช้งานคำสั่ง',
  SetCommandParameters: 'ตั้งค่าพารามิเตอร์คำสั่ง',
  DisplayRuleSettings: 'ตั้งค่ากฎการแสดงผล',
  PleaseCommandForAScenario: 'กรุณาตั้งค่าคำสั่งการทำงานหนึ่งรายการ',
  CommandParameters: 'พารามิเตอร์คำสั่ง',
  SceneRules: 'กฎของสถานการณ์',
  SceneParameters: 'พารามิเตอร์สถานการณ์',
  CommandApplication: 'การใช้งานคำสั่ง',
  TheAsTheOceanConfiguration: 'ชื่อเรียกย่อของฟิลด์การตรวจสอบก่อนจองต้องเหมือนกับการตั้งค่าการจองขนส่งทางทะเล และไม่สนับสนุนการตั้งค่าแยกต่างหาก!',
  TheAsThoseForConfiguration: 'ชื่อเรียกแทนของฟิลด์การมอบหมายการจองสินค้าทางทะเลเหมือนกับการตั้งค่าการจองสินค้าทางทะเล และไม่สนับสนุนการตั้งค่าแบบแยกต่างหาก!',
  TheAsTheAirConfiguration: 'ชื่อเรียกแทนของฟิลด์การจองสินค้าทางอากาศเหมือนกับการตั้งค่าการจองสินค้าทางอากาศ และไม่สนับสนุนการตั้งค่าแยกต่างหาก!',
  TheThoseInTheConfiguration: 'ชื่อเรียกแทนของฟิลด์การสั่งจองทางรถไฟเหมือนกับการตั้งค่าการดำเนินงานทางรถไฟ และไม่สนับสนุนการตั้งค่าแยกต่างหาก!',
  TheOrderInTheConfiguration: 'นามแฝงฟิลด์การตรวจสอบคำสั่งซื้อล่วงหน้าเป็นไปตามการตั้งค่าการจองขนส่งทางอากาศและไม่รองรับการกำหนดค่าแยกต่างหาก！',
  TriggerNodeStatesupConfigured: 'เปิดใช้งานการย้อนกลับสถานะของโหนดอื่น (ตั้งค่าได้สูงสุด 5 รายการ)',
  RollbackBeSetOnlyStartedAbnormal: 'คุณสามารถตั้งค่าการย้อนกลับไปยังสถานะของโหนดอื่นได้ก็ต่อเมื่อ [ประเภทสถานะ] เป็น [ยังไม่เริ่ม]/[ผิดปกติ]',
  PleaseNodeThatNeedsTriggered: 'โปรดตั้งค่าโหนดการย้อนกลับที่จำเป็นต้องถูกเปิดใช้งาน',
  TheNodeCannotBeEmpty: 'โหนดไม่สามารถว่างเปล่าได้',
  TheStatusCannotBeEmpty: 'สถานะของโหนดไม่สามารถเว้นว่างได้',
  AllowStatusToTriggerRollback: 'อนุญาตให้สถานะของโหนดเป็นการกระตุ้นการย้อนกลับ',
  SOPRestrictionsForBusinessDocuments: 'ข้อจำกัดการจับคู่เทมเพลต SOP สำหรับเอกสารธุรกิจ',
  OnlyForTheBranchTemplate: 'เฉพาะการดำเนินการของแอปพลิเคชันที่ตั้งค่าสำหรับสาขาและเทมเพลต HQ',
  OnlyOperationDepartmentAndTemplate: 'เฉพาะแผนกดำเนินการแอปพลิเคชันที่กำหนดและเทมเพลต HQ',
  TabSettings: 'การตั้งค่าแท็บ',
  StandardFeesTab: 'แท็บค่าธรรมเนียมมาตรฐาน',
  HideStandardFeeTab: 'ซ่อนแท็บค่าธรรมเนียมมาตรฐาน',
  DisplayAsASeparateTab: 'แสดงเป็นแท็บแยกต่างหาก',
  DropdownBoxValueDisplay: 'การแสดงค่ากล่องดรอปดาวน์:',
  DisplayRecentlyUsed50Values: 'แสดงค่าข้อมูลล่าสุดที่ใช้ 50 รายการล่าสุด',
  DisplayOrderLogic: 'ตรรกะลำดับการแสดงผล:',
  TheFirstValueTheSequentially: 'ข้อมูลที่บันทึกล่าสุดจะแสดงเป็นค่าแรก ข้อมูลก่อนหน้าที่บันทึกจะแสดงเป็นค่าที่สอง และแสดงตามลำดับต่อไป',
  InstructionPermissions: 'สิทธิ์ในการสั่งการ',
  AllPositions2: 'ทุกตำแหน่ง',
  PleaseAPositionOrPersonnel: 'โปรดเลือกตำแหน่งหรือบุคลากร',
  SalesModule: 'โมดูลการขาย',
  SalesInquiry: 'การสอบถามเกี่ยวกับยอดขาย',
  SalesInquiryApplication: 'แอปพลิเคชันการสอบถามยอดขาย',
  SalesTheCustomTabUI: 'การค้นหาเกี่ยวกับยอดขายช่วยให้แสดงแท็บที่กำหนดเองของอินเทอร์เฟซนี้ได้',
  DisplayCargoPackingInformation: 'แสดงข้อมูลสินค้าที่บรรจุในกล่อง',
  ControlPropertyConfiguration: 'การตั้งค่าคุณสมบัติของคอนโทรล',
  WhenMainTicketDisplayMode: 'เมื่อเอกสารธุรกิจเป็นตั๋วหลัก จะแสดงโหมดการบรรจุตั๋วหลัก',
  UpdatePortDataButton: 'ปุ่มอัปเดตข้อมูลท่าเรือ',
  UIFieldConfiguration: 'การตั้งค่าฟิลด์อินเทอร์เฟซผู้ใช้',
  AutomatedExecution: 'การดำเนินการอัตโนมัติ',
  InvokeAutomatedExecution: 'เรียกใช้งานอัตโนมัติ',
  SOPStatusTrigger: 'การกระตุ้นสถานะ SOP',
  TriggerBasedOnFieldValue: 'ทริกเกอร์ตามค่าฟิลด์',
  DocumentInfo: 'ข้อมูลเอกสาร',
  DocumentTemplate: 'เทมเพลตเอกสาร',
  LocalizedTemplateName: 'ชื่อเทมเพลตที่ปรับ локализованแล้ว',
  TemplateId: 'รหัสเทมเพลต',
  TemplateStatus: 'สถานะเทมเพลต',
  TemplateType: 'ประเภทเทมเพลต',
  TemplateDescription: 'คำอธิบายเทมเพลต',
  LocalizedTemplateDescription: 'คำอธิบายเทมเพลตที่ปรับ локализованแล้ว',
  ApplicableCarrier: 'ผู้ให้บริการที่เกี่ยวข้อง',
  ApplicableSeaport: 'พอร์ตที่เหมาะสม',
  PleaseEnterLocalTemplateName: 'กรุณากรอกชื่อเทมเพลตท้องถิ่น',
  TemplateEnabledPrompt: '【{0}】 - 【{1}】ไฟล์ถูกต้อง หลังจากเปิดใช้งานแล้ว ผู้ใช้อาจนำไปใช้ในงานธุรกิจได้',
  TemplateDisabledPrompt: '【{0}】 - 【{1} หลังจากปิดการใช้งานแล้ว จะไม่สามารถถูกค้นหาหรือใช้งานโดยผู้ใช้ในงานธุรกิจได้',
  TemplateDeletedPrompt: 'กรุณายืนยันว่า [{0}] - [{1}] ถูกลบหรือไม่',
  TriggeredToSpecificBusinessRules: 'ถูกเปิดใช้งานตามกฎธุรกิจเฉพาะ',
  InvoiceInquiryTab: 'แท็บค้นหาใบแจ้งหนี้',
  SetFieldValueSynchronization: 'ตั้งค่าการซิงค์ค่าฟิลด์',
  SourceTab: 'แท็บแหล่งที่มา',
  SourceField: 'ฟิลด์แหล่งที่มา',
  WriteTab: 'แท็บเขียน',
  WriteField: 'เขียนลงในฟิลด์',
  SyncOnlyAtCreation: 'ซิงค์เฉพาะเมื่อสร้าง',
  SynchronizedReceiptWithMainTicket: 'ใบเสร็จที่ซิงค์พร้อมกับตั๋วหลัก',
  AreWantToDeleteData: 'คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลที่เลือกไว้?',
  TheFieldCannotBeEmpty: 'ฟิลด์ 【{0}】 ไม่สามารถเว้นว่างได้',
  ConfirmFieldValueSynchronizationConfiguration: 'ยืนยันการตั้งค่าการซิงค์ค่าฟิลด์หรือไม่?',
  ShippingInformationNonMainInvoice: 'ข้อมูลการจัดส่ง - ไม่ใช่ใบแจ้งหนี้หลัก',
  PleaseSelectFillModeAndForm: 'กรุณาเลือกโหมดการกรอกและแบบฟอร์ม!',
  FillFormCannotBeEmpty: 'แบบฟอร์มการกรอกต้องไม่ว่างเปล่า!',
  BatchModificationPrompt: 'แจ้งเตือนการแก้ไขแบบกลุ่ม',
  ConfirmBatchModification: 'ยืนยันการแก้ไขแบบกลุ่มหรือไม่? การดำเนินการนี้จะทำการแก้ไขงานที่เลือกทั้งหมดพร้อมกัน',
  BatchModificationConfirm: 'ยืนยันการแก้ไขแบบกลุ่ม',
  TemplateApplicationSettings: 'การตั้งค่าการใช้งานเทมเพลต',
  MatchingSettings: 'การตั้งค่าการจับคู่',
  ManualSOPTemplatesIsAllowed: 'ห้ามเปลี่ยนเทมเพลต SOP โดยการดำเนินการด้วยมือ',
  DoTemplateIsAutomaticallyTemplate: 'ไม่แสดงคำเตือนเมื่อเทมเพลตถูกจับคู่อัตโนมัติกับเทมเพลตใหม่',
  ContainerMaxNumTip: 'จำนวนกล่องไม่สามารถเกิน [{0}] กล่องได้ หากมีความต้องการเกินจำนวนนี้ โปรดติดต่อฝ่ายบริการลูกค้าเพื่อปรับเกณฑ์พารามิเตอร์ [ContainerMaxNum]',
  BatchOperationSettings: 'การตั้งค่าการดำเนินการแบบหมู่',
  BatchOperationsSupported: 'รองรับการดำเนินการเป็นกลุ่ม',
  BulkOperationPrompt: 'คำแนะนำการดำเนินการแบบจำนวนมาก',
  PleaseSelectRailwayExportServices: 'โปรดเลือกบริการส่งออกทางรถไฟ',
  PleaseSelectRailwayImportBusiness: 'โปรดเลือกธุรกิจนำเข้าทางรถไฟ',
  BatchAllowedPleaseSelectRecord: 'ไม่สามารถดำเนินการเป็นกลุ่มได้ กรุณาเลือกบันทึกเดียว',
  AreWantToPerformOperation: 'คุณแน่ใจหรือไม่ว่าต้องการดำเนินการแบบจำนวนมาก!',
  NonNotSupportCrossTenants: 'บริษัทที่ไม่ใช่ส่วนหนึ่งของกลุ่ม ไม่สนับสนุนการมอบหมายงานข้ามผู้เช่า',
  NoBusinessCanBeEntrusted: 'ไม่มีงานที่สามารถมอบหมายได้',
  PleaseSelect0: 'โปรดเลือก {0}',
  ShippingInformationMasterBill: 'ข้อมูลการบรรจุ - เอกสารขนส่งหลัก',
  HideDefaultButton: 'ซ่อนปุ่มค่าเริ่มต้น',
  AdditionalReceivables: 'รายได้ที่ต้องรับเพิ่มเติม',
  AdditionalPayable: 'หนี้สินเพิ่มเติม'
}
